import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onMount } from "svelte";
import { SvelteMap, SvelteSet } from "svelte/reactivity";
import { MvgDepartureRepository } from "../adapters/mvg/mvg-departure-repository.js";

var root = $.from_html(`<button><div class="target-icon-current svelte-15jn9j3"> </div> <div class="target-text svelte-15jn9j3"><strong class="svelte-15jn9j3">Current Route</strong> <span class="svelte-15jn9j3">Update this route's config</span></div></button>`);
var root_1 = $.from_html(`<div class="step-content svelte-15jn9j3"><p class="svelte-15jn9j3">Routes let you have different views.</p> <p class="svelte-15jn9j3">Choose whether to set up your main departures board or a route:</p> <div class="target-options svelte-15jn9j3"><button><div class="target-icon-main svelte-15jn9j3">🏠</div> <div class="target-text svelte-15jn9j3"><strong class="svelte-15jn9j3">Main</strong> <span class="svelte-15jn9j3">Your main departures board</span></div></button> <!> <button><div class="target-icon-new svelte-15jn9j3">+</div> <div class="target-text svelte-15jn9j3"><strong class="svelte-15jn9j3">New Route</strong> <span class="svelte-15jn9j3">Create a separate route</span></div></button></div></div>`);
var root_2 = $.from_html(`<div class="step-content svelte-15jn9j3"><h3 class="svelte-15jn9j3">New Route Details</h3> <p class="svelte-15jn9j3">Provide a title and URL path for your new route:</p> <div class="route-form svelte-15jn9j3"><div class="form-field svelte-15jn9j3"><label for="route-title" class="svelte-15jn9j3">Route Title</label> <input id="route-title" type="text" placeholder="e.g., Ostbahnhof Departures" class="form-input svelte-15jn9j3"/> <span class="field-hint svelte-15jn9j3">This will be displayed as the page title</span></div> <div class="form-field svelte-15jn9j3"><label for="route-path" class="svelte-15jn9j3">Route Path</label> <div class="path-input-wrapper svelte-15jn9j3"><span class="path-prefix svelte-15jn9j3">/</span> <input id="route-path" type="text" placeholder="e.g., hochaeckerstrasse" class="form-input path-input svelte-15jn9j3"/></div> <span class="field-hint svelte-15jn9j3"> </span></div></div></div>`);
var root_3 = $.from_html(`<div class="error-message svelte-15jn9j3" role="alert"> </div>`);
var root_4 = $.from_html(`<span class="result-place svelte-15jn9j3"> </span>`);
var root_5 = $.from_html(`<div class="result-item svelte-15jn9j3"><span class="result-info svelte-15jn9j3"><strong> </strong> <!></span> <span class="result-id svelte-15jn9j3"> </span></div>`);
var root_6 = $.from_html(`<div class="results-list svelte-15jn9j3"><p class="results-count svelte-15jn9j3"> </p> <!></div>`);
var root_7 = $.from_html(`<div class="step-content svelte-15jn9j3"><h3 class="svelte-15jn9j3">Step 1: Search for Stops</h3> <p class="svelte-15jn9j3">Search for a transit stop by name:</p> <div class="search-container svelte-15jn9j3"><input type="text" placeholder="e.g., Giesing München" class="search-input svelte-15jn9j3"/> <button class="search-button svelte-15jn9j3"> </button></div> <!> <!></div>`);
var root_8 = $.from_html(`<span class="stop-place svelte-15jn9j3"> </span>`);
var root_9 = $.from_html(`<label class="checkbox-item svelte-15jn9j3"><input type="checkbox" class="svelte-15jn9j3"/> <span class="checkbox-label svelte-15jn9j3"><strong> </strong> <span class="stop-meta svelte-15jn9j3"><!> <span class="stop-id svelte-15jn9j3"> </span></span></span></label>`);
var root_10 = $.from_html(`<div class="step-content svelte-15jn9j3"><h3 class="svelte-15jn9j3">Step 2: Select Stops</h3> <p class="svelte-15jn9j3">Select which stops you want to configure.</p> <p class="svelte-15jn9j3">You will be able to select physical stops in the next step.</p> <div class="stops-checklist svelte-15jn9j3"></div></div>`);
var root_11 = $.from_html(`<div class="loading-indicator svelte-15jn9j3">Loading route information...</div>`);
var root_12 = $.from_html(`<div class="context-item svelte-15jn9j3"><strong> </strong> </div>`);
var root_13 = $.from_html(`<div class="substop-title-input svelte-15jn9j3"><label class="svelte-15jn9j3">Title:</label> <input type="text" placeholder="e.g., Stop 2, Towards Giesing" class="svelte-15jn9j3"/></div>`);
var root_14 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 25 25" class="route-icon svelte-15jn9j3" aria-hidden="true"><rect fill="#00508c" width="25" height="25"></rect><path fill="#fff" d="M20.9,2h-5v13.1c0,2.4-.8,4.1-3.4,4.1s-3.5-1.7-3.5-4.1V2h-4.9v13.5c0,5.7,4.6,7.8,8.4,7.8s8.4-2.1,8.4-7.8V2s0,0,0,0Z"></path></svg>`);
var root_15 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.98 31.98" class="route-icon svelte-15jn9j3" aria-hidden="true"><path d="M15.99,0A15.99,15.99,0,1,0,31.98,15.99,16.023,16.023,0,0,0,15.99,0" fill="#009551" fill-rule="evenodd"></path><path d="M25.67,6.31c0,4.74-.04,4.66-.04,4.66C23.29,8.68,14.77,5.05,13.08,7.86c-1.99,3.31,4.32,4.53,9.48,6.29,6.15,2.1,6.06,9.19,1.58,12.61-5.93,4.52-13.23,2.38-18.69-1.71V20.16c1.3,1.52,3.44,2.52,6.47,3.61,1.72.62,6.13,1.59,7.26-.41,1.52-2.69-2.43-3.54-4.02-3.83a16.155,16.155,0,0,1-6.35-2.44c-4.64-3.07-4.42-9.04.11-12.23C14,1.27,21.12,2.52,25.67,6.31" fill="#fff" fill-rule="evenodd"></path></svg>`);
var root_16 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="route-icon svelte-15jn9j3" aria-hidden="true"><rect width="32" height="32" fill="#dd0b2f"></rect><path d="M18.9,11.8h2.01v1.38a2.719,2.719,0,0,1,2.43-1.59a1.758,1.758,0,0,1,1.13.36A2.972,2.972,0,0,1,25.24,13a2.567,2.567,0,0,1,2.38-1.41a1.847,1.847,0,0,1,1.62.79a3.47,3.47,0,0,1,.5,2.02v4.81H27.56V15.39c0-1.13-.32-1.7-.97-1.7a1,1,0,0,0-.92.68a3.158,3.158,0,0,0-.25,1.33v3.5H23.23V15.16c0-.99-.32-1.48-.96-1.48a1.013,1.013,0,0,0-.94.76a3.694,3.694,0,0,0-.24,1.4V19.2H18.9V11.8m-3.73,4.06a1.611,1.611,0,0,0-.87.23a1.005,1.005,0,0,0-.19,1.53.829.829,0,0,0,.62.25a1.107,1.107,0,0,0,.99-.6a2.53,2.53,0,0,0,.32-1.3l-.01-.04C15.54,15.88,15.25,15.86,15.17,15.86Zm.84-1.28v-.21a1.018,1.018,0,0,0-.51-.89a1.785,1.785,0,0,0-.95-.28a5.384,5.384,0,0,0-1.91.57V12.1a5.613,5.613,0,0,1,2.38-.47q3.045,0,3.04,3.19v4.4H16.18V18.09a4.924,4.924,0,0,1-.94,1a2.094,2.094,0,0,1-1.24.32a2.081,2.081,0,0,1-1.6-.71a2.6,2.6,0,0,1-.64-1.83a2,2,0,0,1,1.58-2.07A10.788,10.788,0,0,1,16.01,14.58ZM9.13,11.8l.06,1.51a3.412,3.412,0,0,1,.68-1.18a1.556,1.556,0,0,1,1.14-.42c.09,0,.32.03.69.07l-.05,2.18a2.9,2.9,0,0,0-.79-.1c-1,0-1.5.77-1.5,2.3v3.07H7.17V13.7c0-.31-.02-.95-.06-1.91H9.13ZM1.3,9.37H7.71v1.97H5.66V19.2H3.4V11.34H1.3Z" fill="#fff" fill-rule="evenodd"></path></svg>`);
var root_17 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92.81 122.88" class="route-icon svelte-15jn9j3" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M66.69,101.35H26.68l-4.7,6.94h49.24L66.69,101.35L66.69,101.35z M17.56,114.81l-5.47,8.07H0l19.64-29.46 h-3.49c-4.76,0-8.66-3.9-8.66-8.66V8.66C7.5,3.9,11.39,0,16.15,0h61.22c4.76,0,8.66,3.9,8.66,8.66v76.1c0,4.76-3.9,8.66-8.66,8.66 h-3.4l18.83,29.04H80.45l-4.99-7.65H17.56L17.56,114.81z M62.97,67.66h10.48c1.14,0,2.07,0.93,2.07,2.07V80.2 c0,1.14-0.93,2.07-2.07,2.07H62.97c-1.14,0-2.07-0.93-2.07-2.07V69.72C60.9,68.59,61.83,67.66,62.97,67.66L62.97,67.66z M18.98,67.66h10.48c1.14,0,2.07,0.93,2.07,2.07V80.2c0,1.14-0.93,2.07-2.07,2.07H18.98c-1.14,0-2.07-0.93-2.07-2.07V69.72 C16.91,68.59,17.84,67.66,18.98,67.66L18.98,67.66z M25.1,16.7h42.81c4.6,0,8.36,3.76,8.36,8.37v13.17c0,4.6-3.76,8.36-8.36,8.36 H25.1c-4.6,0-8.36-3.76-8.36-8.36V25.07C16.74,20.47,20.5,16.7,25.1,16.7L25.1,16.7z M38.33,3.8h16.2C55.34,3.8,56,4.46,56,5.27 v6.38c0,0.81-0.66,1.47-1.47,1.47h-16.2c-0.81,0-1.47-0.66-1.47-1.47V5.27C36.85,4.46,37.51,3.8,38.33,3.8L38.33,3.8z"></path></svg>`);
var root_18 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="route-icon svelte-15jn9j3" aria-hidden="true"><path d="M16,0A16,16,0,1,1,0,16,16.034,16.034,0,0,1,16,0" fill="#005d79" fill-rule="evenodd"></path><path d="M28.43,12.85a7.084,7.084,0,0,0-2.25-.56q-1.68,0-1.68,1.08c0,.46.39.84,1.18,1.15a10.3,10.3,0,0,1,2.21,1.02a3.178,3.178,0,0,1,1.19,2.7a3.2,3.2,0,0,1-1.33,2.8a4.846,4.846,0,0,1-2.85.78a10.854,10.854,0,0,1-3.09-.57l.23-2.38a6.584,6.584,0,0,0,2.69.7c1.08,0,1.62-.37,1.62-1.12,0-.51-.4-.93-1.19-1.27a16.466,16.466,0,0,1-2.2-1.03a2.906,2.906,0,0,1-1.19-2.49A3.1,3.1,0,0,1,23.1,10.9a4.932,4.932,0,0,1,2.83-.73a11.091,11.091,0,0,1,2.7.45l-.2,2.23M12.35,10.47h2.62v7.04a2.58,2.58,0,0,0,.4,1.52a1.476,1.476,0,0,0,1.26.62c1.03,0,1.55-.81,1.55-2.43V10.47h2.63V17.6a4.05,4.05,0,0,1-1.28,3.2a4.48,4.48,0,0,1-3.05,1.02a4.185,4.185,0,0,1-2.85-1a3.709,3.709,0,0,1-1.28-2.96Zm-4.8,9.04a1.2,1.2,0,0,0,.88-.38a1.274,1.274,0,0,0,.38-.94c0-.84-.55-1.27-1.65-1.27H6.06V19.5H7.55Zm-.53-4.57a1.771,1.771,0,0,0,1.02-.28A1.129,1.129,0,0,0,8.1,12.8a1.521,1.521,0,0,0-.93-.3H6.05v2.45h.97ZM3.47,10.45H8a3.514,3.514,0,0,1,2.13.62a2.454,2.454,0,0,1,1,2.12a3.087,3.087,0,0,1-.41,1.71a2.761,2.761,0,0,1-1.33.99a2.506,2.506,0,0,1,2.02,2.72q0,2.97-4.07,2.97H3.46V10.45Z" fill="#fff" fill-rule="evenodd"></path></svg>`);
var root_19 = $.from_html(`<div class="route-row svelte-15jn9j3"><span class="route-number svelte-15jn9j3"><!> <span class="route-line-text svelte-15jn9j3"> </span></span> <span class="route-dest svelte-15jn9j3"> </span></div>`);
var root_20 = $.from_html(`<div class="substop-routes svelte-15jn9j3"><span class="routes-label svelte-15jn9j3">Routes:</span> <div class="route-list svelte-15jn9j3"></div></div>`);
var root_21 = $.from_html(`<div class="substop-routes svelte-15jn9j3"><span class="no-routes svelte-15jn9j3">No route info available</span></div>`);
var root_22 = $.from_html(`<div><label class="substop-checkbox-label svelte-15jn9j3"><input type="checkbox" class="svelte-15jn9j3"/> <span class="substop-info svelte-15jn9j3"><span class="substop-name svelte-15jn9j3"> </span> <span class="substop-id svelte-15jn9j3"> </span></span></label> <!> <!></div>`);
var root_23 = $.from_html(`<div class="substop-group svelte-15jn9j3"><h4 class="substop-group-title svelte-15jn9j3"> </h4> <label class="full-stop-checkbox svelte-15jn9j3"><input type="checkbox" class="svelte-15jn9j3"/> <span>Select full stop (with route mappings)</span></label> <div class="substop-options svelte-15jn9j3"></div></div>`);
var root_24 = $.from_html(`<p class="info-text svelte-15jn9j3">💡 If no substops are selected, the main stop will show all routes from all platforms</p>`);
var root_25 = $.from_html(`<div class="substops-context svelte-15jn9j3"></div> <div class="substops-list svelte-15jn9j3"></div> <!>`, 1);
var root_26 = $.from_html(`<div class="step-content svelte-15jn9j3"><h3 class="svelte-15jn9j3">Step 2b: Configure Physical Stops</h3> <p class="svelte-15jn9j3">Choose which platforms to monitor and set custom names:</p> <!></div>`);
var root_27 = $.from_html(`<p class="inline-error svelte-15jn9j3">⚠️ Title is required</p>`);
var root_28 = $.from_html(`<button><span class="route-filter-line svelte-15jn9j3"><!> <span class="route-line-text svelte-15jn9j3"> </span></span> <span class="route-filter-dest svelte-15jn9j3"> </span></button>`);
var root_29 = $.from_html(`<p class="inline-error svelte-15jn9j3">⚠️ Select at least one route for this group</p>`);
var root_30 = $.from_html(`<div class="direction-group-card svelte-15jn9j3"><div class="direction-group-header svelte-15jn9j3"><input type="text" placeholder="e.g., Towards City, Northbound"/> <button class="button-remove-group svelte-15jn9j3" aria-label="Remove group">×</button></div> <!> <div class="direction-group-routes svelte-15jn9j3"><p class="routes-select-label svelte-15jn9j3">Select routes for this group:</p> <div class="route-filter-options svelte-15jn9j3"></div> <!></div></div>`);
var root_31 = $.from_html(`<p class="info-text svelte-15jn9j3">💡 Click "Add Direction Group" to create groups for this platform</p>`);
var root_32 = $.from_html(`<div class="direction-mappings-container svelte-15jn9j3"><div class="direction-mappings-header svelte-15jn9j3"><h4 class="svelte-15jn9j3"> </h4> <button class="button-add-group svelte-15jn9j3">+ Add Direction Group</button></div> <!> <!></div>`);
var root_33 = $.from_html(`<p class="info-text svelte-15jn9j3">💡 Click "Add Direction Group" to create groups for the main stop</p>`);
var root_34 = $.from_html(`<!> <!> <!>`, 1);
var root_35 = $.from_html(`<h3 class="svelte-15jn9j3">Step 3: Configure Direction Mappings</h3> <p class="svelte-15jn9j3">Create groups of routes with custom titles for each platform (e.g., "Towards City", "Northbound"). Each group will show the selected routes.</p> <div class="direction-mappings-list svelte-15jn9j3"><!> <!></div>`, 1);
var root_36 = $.from_html(`<span class="route-filter-count svelte-15jn9j3"> </span>`);
var root_37 = $.from_html(`<div class="route-filter-group svelte-15jn9j3"><h4 class="route-filter-title svelte-15jn9j3"> <!></h4> <div class="route-filter-options svelte-15jn9j3"></div></div>`);

var root_38 = $.from_html(
	`<h3 class="svelte-15jn9j3">Step 3: Filter Routes (Optional)</h3> <p class="svelte-15jn9j3">Select which routes you want to display for each platform. If none are selected, all routes will be shown.</p> <div class="route-filter-list svelte-15jn9j3"></div> <p class="info-text svelte-15jn9j3">💡 Filtering routes helps reduce clutter when you only care about specific lines.
              Only line numbers are stored (e.g. 54, 134)—destinations are ignored. Night buses like N44 are separate from 44.</p>`,
	1
);

var root_39 = $.from_html(`<div class="step-content svelte-15jn9j3"><!></div>`);
var root_40 = $.from_html(`<span class="route-chip-small svelte-15jn9j3"> </span>`);
var root_41 = $.from_html(`<span class="no-routes svelte-15jn9j3">(no routes selected)</span>`);
var root_42 = $.from_html(`<div class="mapping-item svelte-15jn9j3"><strong> </strong> <div class="mapping-routes svelte-15jn9j3"><!></div></div>`);
var root_43 = $.from_html(`<div class="config-item svelte-15jn9j3"><h4 class="svelte-15jn9j3"> </h4> <div class="config-fields svelte-15jn9j3"><div class="field svelte-15jn9j3"><span class="field-label svelte-15jn9j3">Station ID:</span> <code class="svelte-15jn9j3"> </code></div> <div class="field svelte-15jn9j3"><span class="field-label svelte-15jn9j3">Show ungrouped:</span> <span>false</span></div> <div class="field svelte-15jn9j3"><span class="field-label svelte-15jn9j3">Direction mappings:</span> <div class="mappings-preview svelte-15jn9j3"></div></div></div></div>`);
var root_44 = $.from_html(`<div class="field svelte-15jn9j3"><span class="field-label svelte-15jn9j3">Show ungrouped:</span> <span>false</span></div> <div class="field svelte-15jn9j3"><span class="field-label svelte-15jn9j3">Direction mappings:</span> <div class="mappings-preview svelte-15jn9j3"></div></div>`, 1);
var root_45 = $.from_html(`<div class="field svelte-15jn9j3"><span class="field-label svelte-15jn9j3">Filtered routes:</span> <div class="route-chips"></div></div>`);
var root_46 = $.from_html(`<div class="field svelte-15jn9j3"><span class="field-label svelte-15jn9j3">Show ungrouped:</span> <span>true</span></div> <!>`, 1);
var root_47 = $.from_html(`<div class="config-item svelte-15jn9j3"><h4 class="svelte-15jn9j3"> </h4> <div class="config-fields svelte-15jn9j3"><div class="field svelte-15jn9j3"><span class="field-label svelte-15jn9j3">Station ID:</span> <code class="svelte-15jn9j3"> </code></div> <div class="field svelte-15jn9j3"><span class="field-label svelte-15jn9j3">Title:</span> <span> </span></div> <!> <div class="field svelte-15jn9j3"><span class="field-label svelte-15jn9j3">Max departures per stop:</span> <span>4</span></div> <div class="field svelte-15jn9j3"><span class="field-label svelte-15jn9j3">Max departures per route:</span> <span>2</span></div></div></div>`);
var root_48 = $.from_html(`<div class="step-content svelte-15jn9j3"><h3 class="svelte-15jn9j3">Step 3: Review Configuration</h3> <p class="svelte-15jn9j3">Selected stops and their configuration:</p> <div class="config-preview svelte-15jn9j3"><!> <!></div> <p class="info-text svelte-15jn9j3">💡 You can fine-tune these settings by editing the generated TOML config</p></div>`);
var root_49 = $.from_html(`<button class="button button-secondary svelte-15jn9j3">Cancel</button>`);
var root_50 = $.from_html(`<button class="button button-secondary svelte-15jn9j3">Back</button> <button class="button button-secondary svelte-15jn9j3">Cancel</button> <button class="button button-primary svelte-15jn9j3">Next</button>`, 1);
var root_51 = $.from_html(`<button class="button button-secondary svelte-15jn9j3">Back</button> <button class="button button-secondary svelte-15jn9j3">Cancel</button>`, 1);
var root_52 = $.from_html(`<button class="button button-secondary svelte-15jn9j3">Back</button> <button class="button button-secondary svelte-15jn9j3">Cancel</button> <button class="button button-primary svelte-15jn9j3"> </button>`, 1);
var root_53 = $.from_html(`<button class="button button-secondary svelte-15jn9j3">Back</button> <button class="button button-secondary svelte-15jn9j3">Cancel</button> <button class="button button-primary svelte-15jn9j3">Create Configuration</button>`, 1);
var root_54 = $.from_html(`<div class="wizard-overlay svelte-15jn9j3" role="button" tabindex="0" aria-label="Close wizard dialog"><div class="wizard-content svelte-15jn9j3"><div class="wizard-header svelte-15jn9j3"><h2 class="svelte-15jn9j3">Configuration Wizard</h2> <button class="close-button svelte-15jn9j3" aria-label="Close">×</button></div> <div class="wizard-body svelte-15jn9j3"><!></div> <div class="wizard-footer svelte-15jn9j3"><!></div></div></div>`);

const $$css = {
	hash: 'svelte-15jn9j3',
	code: '.wizard-overlay.svelte-15jn9j3 {position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0, 0, 0, 0.5);display:flex;align-items:center;justify-content:center;z-index:10001;}.wizard-content.svelte-15jn9j3 {background:white;border-radius:0.5rem;padding:1.5rem;max-width:90vw;max-height:90vh;min-height:500px;width:700px;display:flex;flex-direction:column;box-shadow:0 20px 25px -5px rgba(0, 0, 0, 0.1);overflow:hidden;}\n\n  @media (max-width: 640px) {.wizard-content.svelte-15jn9j3 {max-width:100vw;max-height:100vh;max-height:100dvh;min-height:100vh;min-height:100dvh;width:100vw;border-radius:0;padding:1rem;}\n  }[data-theme="dark"] .wizard-content.svelte-15jn9j3 {background:#1d232a;color:#f9fafb;}.wizard-header.svelte-15jn9j3 {display:flex;justify-content:space-between;align-items:center;margin-bottom:1rem;}.wizard-header.svelte-15jn9j3 h2:where(.svelte-15jn9j3) {margin:0;font-size:1.5rem;font-weight:700;}\n\n  @media (max-width: 640px) {.wizard-header.svelte-15jn9j3 h2:where(.svelte-15jn9j3) {font-size:1.25rem;}\n  }.close-button.svelte-15jn9j3 {background:none;border:none;font-size:2rem;cursor:pointer;padding:0;width:2rem;height:2rem;display:flex;align-items:center;justify-content:center;color:#6b7280;}.close-button.svelte-15jn9j3:hover {color:#111827;}[data-theme="dark"] .close-button.svelte-15jn9j3 {color:#9ca3af;}[data-theme="dark"] .close-button.svelte-15jn9j3:hover {color:#f9fafb;}.wizard-body.svelte-15jn9j3 {flex:1 1 auto;overflow-y:auto;margin-bottom:1rem;}.step-content.svelte-15jn9j3 h3:where(.svelte-15jn9j3) {margin:0 0 0.5rem 0;font-size:1rem;font-weight:600;}\n\n  @media (max-width: 640px) {.step-content.svelte-15jn9j3 h3:where(.svelte-15jn9j3) {font-size:0.95rem;}\n  }.step-content.svelte-15jn9j3 > p:where(.svelte-15jn9j3) {margin:0 0 0.75rem 0;color:#6b7280;font-size:0.875rem;}.target-options.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.75rem;margin-bottom:1rem;}.target-button.svelte-15jn9j3 {display:flex;gap:1rem;align-items:center;padding:1rem;border:2px solid #e5e7eb;border-radius:0.5rem;background:white;cursor:pointer;transition:all 0.2s;text-align:left;}\n\n  @media (max-width: 640px) {.target-button.svelte-15jn9j3 {gap:0.75rem;padding:0.75rem;}\n  }.target-button.svelte-15jn9j3:hover {border-color:#087bc4;background-color:#f0f9ff;}.target-button.active.svelte-15jn9j3 {border-color:#087bc4;background-color:#dbeafe;}[data-theme="dark"] .target-button.svelte-15jn9j3 {background:#111827;border-color:#374151;}[data-theme="dark"] .target-button.svelte-15jn9j3:hover {border-color:#60a5fa;background-color:#1e3a8a;}[data-theme="dark"] .target-button.active.svelte-15jn9j3 {border-color:#60a5fa;background-color:#1e3a8a;}.target-icon-main.svelte-15jn9j3 {font-size:2.5rem;flex-shrink:0;line-height:1;}\n\n  @media (max-width: 640px) {.target-icon-main.svelte-15jn9j3 {font-size:2rem;}\n  }.target-icon-current.svelte-15jn9j3 {font-size:1.2rem;font-weight:bold;flex-shrink:0;line-height:1;text-transform:uppercase;letter-spacing:0.5px;color:#087bc4;background-color:#dbeafe;padding:0.5rem 0.75rem;border-radius:0.375rem;min-width:3rem;text-align:center;}\n\n  @media (max-width: 640px) {.target-icon-current.svelte-15jn9j3 {font-size:0.9rem;padding:0.4rem 0.6rem;min-width:2.5rem;}\n  }[data-theme="dark"] .target-icon-current.svelte-15jn9j3 {color:#93c5fd;background-color:#1e3a8a;}.target-icon-new.svelte-15jn9j3 {font-size:3rem;flex-shrink:0;line-height:1;font-weight:300;color:#10b981;}\n\n  @media (max-width: 640px) {.target-icon-new.svelte-15jn9j3 {font-size:2rem;}\n  }.target-button-new.svelte-15jn9j3 .target-icon-new:where(.svelte-15jn9j3) {color:#10b981;}[data-theme="dark"] .target-button-new.svelte-15jn9j3 .target-icon-new:where(.svelte-15jn9j3) {color:#6ee7b7;}.target-text.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.25rem;}.target-text.svelte-15jn9j3 strong:where(.svelte-15jn9j3) {font-size:1rem;}.target-text.svelte-15jn9j3 span:where(.svelte-15jn9j3) {font-size:0.8rem;color:#6b7280;}[data-theme="dark"] .target-text.svelte-15jn9j3 span:where(.svelte-15jn9j3) {color:#9ca3af;}[data-theme="dark"] .step-content.svelte-15jn9j3 > p:where(.svelte-15jn9j3) {color:#9ca3af;}.search-container.svelte-15jn9j3 {display:flex;gap:0.5rem;margin-bottom:0.75rem;}\n\n  @media (max-width: 640px) {.search-container.svelte-15jn9j3 {flex-direction:column;}\n  }.search-input.svelte-15jn9j3 {flex:1;padding:0.75rem;border:1px solid #d1d5db;border-radius:0.375rem;font-size:1rem;box-sizing:border-box;}.search-input.svelte-15jn9j3:disabled {opacity:0.5;cursor:not-allowed;}[data-theme="dark"] .search-input.svelte-15jn9j3 {background:#111827;color:#f9fafb;border-color:#374151;}.search-button.svelte-15jn9j3 {padding:0.75rem 1.5rem;background-color:#087bc4;color:white;border:none;border-radius:0.375rem;font-weight:500;cursor:pointer;transition:background-color 0.2s;white-space:nowrap;}\n\n  @media (max-width: 640px) {.search-button.svelte-15jn9j3 {width:100%;padding:0.875rem;}\n  }.search-button.svelte-15jn9j3:hover:not(:disabled) {background-color:#0669a3;}.search-button.svelte-15jn9j3:disabled {opacity:0.5;cursor:not-allowed;}.error-message.svelte-15jn9j3 {background-color:#fee2e2;border:1px solid #fca5a5;border-radius:0.375rem;padding:0.75rem;margin-bottom:1rem;color:#991b1b;font-size:0.875rem;}[data-theme="dark"] .error-message.svelte-15jn9j3 {background-color:#7f1d1d;border-color:#dc2626;color:#fca5a5;}.results-list.svelte-15jn9j3 {border:1px solid #e5e7eb;border-radius:0.375rem;overflow:hidden;}[data-theme="dark"] .results-list.svelte-15jn9j3 {border-color:#374151;}.results-count.svelte-15jn9j3 {margin:0;padding:0.75rem;background-color:#f9fafb;font-size:0.875rem;font-weight:500;}[data-theme="dark"] .results-count.svelte-15jn9j3 {background-color:#111827;}.result-item.svelte-15jn9j3 {padding:0.75rem;border-top:1px solid #e5e7eb;display:flex;justify-content:space-between;align-items:center;cursor:pointer;transition:background-color 0.2s;}\n\n  @media (max-width: 640px) {.result-item.svelte-15jn9j3 {flex-direction:column;align-items:flex-start;gap:0.5rem;padding:0.5rem;}\n  }.result-item.svelte-15jn9j3:hover {background-color:#f3f4f6;}[data-theme="dark"] .result-item.svelte-15jn9j3 {border-top-color:#374151;}[data-theme="dark"] .result-item.svelte-15jn9j3:hover {background-color:#374151;}.result-info.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.25rem;}.result-place.svelte-15jn9j3 {font-size:0.875rem;color:#6b7280;}[data-theme="dark"] .result-place.svelte-15jn9j3 {color:#9ca3af;}.result-id.svelte-15jn9j3 {font-size:0.75rem;color:#9ca3af;font-family:monospace;}.stops-checklist.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.25rem;}.checkbox-item.svelte-15jn9j3 {display:flex;align-items:flex-start;gap:0.5rem;padding:0.4rem 0.5rem;border:1px solid #d1d5db;border-radius:0.25rem;cursor:pointer;transition:background-color 0.2s;font-size:0.875rem;}.checkbox-item.svelte-15jn9j3:hover {background-color:#f9fafb;}[data-theme="dark"] .checkbox-item.svelte-15jn9j3 {border-color:#374151;}[data-theme="dark"] .checkbox-item.svelte-15jn9j3:hover {background-color:#111827;}.checkbox-item.svelte-15jn9j3 input[type="checkbox"]:where(.svelte-15jn9j3) {margin-top:0.15rem;cursor:pointer;flex-shrink:0;}.checkbox-item.svelte-15jn9j3 input[type="checkbox"]:where(.svelte-15jn9j3):disabled {cursor:not-allowed;opacity:0.5;}.checkbox-label.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.1rem;flex:1;}.stop-meta.svelte-15jn9j3 {display:flex;gap:0.5rem;align-items:center;font-size:0.7rem;}.stop-place.svelte-15jn9j3 {color:#6b7280;}[data-theme="dark"] .stop-place.svelte-15jn9j3 {color:#9ca3af;}.stop-id.svelte-15jn9j3 {font-family:monospace;color:#9ca3af;background-color:#f3f4f6;padding:0.1rem 0.3rem;border-radius:0.15rem;}[data-theme="dark"] .stop-id.svelte-15jn9j3 {color:#d1d5db;background-color:#374151;}.config-preview.svelte-15jn9j3 {display:flex;flex-direction:column;gap:1rem;}.config-item.svelte-15jn9j3 {border:1px solid #d1d5db;border-radius:0.375rem;padding:1rem;}[data-theme="dark"] .config-item.svelte-15jn9j3 {border-color:#374151;background-color:#111827;}.config-item.svelte-15jn9j3 h4:where(.svelte-15jn9j3) {margin:0 0 0.75rem 0;font-size:1rem;}.config-fields.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.5rem;}.field.svelte-15jn9j3 {display:flex;justify-content:space-between;align-items:center;font-size:0.875rem;}.field.svelte-15jn9j3 .field-label:where(.svelte-15jn9j3) {font-weight:500;color:#6b7280;}[data-theme="dark"] .field.svelte-15jn9j3 .field-label:where(.svelte-15jn9j3) {color:#9ca3af;}.field.svelte-15jn9j3 code:where(.svelte-15jn9j3) {background-color:#f3f4f6;padding:0.25rem 0.5rem;border-radius:0.25rem;font-family:monospace;font-size:0.8rem;}[data-theme="dark"] .field.svelte-15jn9j3 code:where(.svelte-15jn9j3) {background-color:#374151;}.info-text.svelte-15jn9j3 {margin:1rem 0 0 0;padding:0.75rem;background-color:#dbeafe;border-radius:0.375rem;font-size:0.875rem;color:#1e40af;}[data-theme="dark"] .info-text.svelte-15jn9j3 {background-color:#1e3a8a;color:#93c5fd;}.wizard-footer.svelte-15jn9j3 {display:flex;justify-content:flex-end;gap:0.75rem;flex-shrink:0;margin-top:auto;}\n\n  @media (max-width: 640px) {.wizard-footer.svelte-15jn9j3 {flex-direction:column-reverse;gap:0.5rem;}\n  }.button.svelte-15jn9j3 {padding:0.5rem 1rem;border-radius:0.375rem;font-weight:500;cursor:pointer;border:none;transition:background-color 0.2s;}\n\n  @media (max-width: 640px) {.button.svelte-15jn9j3 {width:100%;padding:0.75rem;}\n  }.button.svelte-15jn9j3:disabled {opacity:0.5;cursor:not-allowed;}.button-primary.svelte-15jn9j3 {background-color:#087bc4;color:white;}.button-primary.svelte-15jn9j3:hover:not(:disabled) {background-color:#0669a3;}.button-secondary.svelte-15jn9j3 {background-color:#e5e7eb;color:#111827;}.button-secondary.svelte-15jn9j3:hover {background-color:#d1d5db;}[data-theme="dark"] .button-secondary.svelte-15jn9j3 {background-color:#374151;color:#f9fafb;}[data-theme="dark"] .button-secondary.svelte-15jn9j3:hover {background-color:#4b5563;}.route-form.svelte-15jn9j3 {display:flex;flex-direction:column;gap:1.25rem;}.form-field.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.5rem;}.form-field.svelte-15jn9j3 label:where(.svelte-15jn9j3) {font-weight:600;font-size:0.875rem;color:#374151;}[data-theme="dark"] .form-field.svelte-15jn9j3 label:where(.svelte-15jn9j3) {color:#d1d5db;}.form-input.svelte-15jn9j3 {padding:0.75rem;border:1px solid #d1d5db;border-radius:0.375rem;font-size:1rem;box-sizing:border-box;width:100%;}.form-input.svelte-15jn9j3:focus {outline:none;border-color:#087bc4;box-shadow:0 0 0 3px rgba(8, 123, 196, 0.1);}[data-theme="dark"] .form-input.svelte-15jn9j3 {background:#111827;color:#f9fafb;border-color:#374151;}[data-theme="dark"] .form-input.svelte-15jn9j3:focus {border-color:#60a5fa;box-shadow:0 0 0 3px rgba(96, 165, 250, 0.1);}.path-input-wrapper.svelte-15jn9j3 {display:flex;align-items:center;gap:0;border:1px solid #d1d5db;border-radius:0.375rem;overflow:hidden;}.path-input-wrapper.svelte-15jn9j3:focus-within {border-color:#087bc4;box-shadow:0 0 0 3px rgba(8, 123, 196, 0.1);}[data-theme="dark"] .path-input-wrapper.svelte-15jn9j3 {border-color:#374151;}[data-theme="dark"] .path-input-wrapper.svelte-15jn9j3:focus-within {border-color:#60a5fa;box-shadow:0 0 0 3px rgba(96, 165, 250, 0.1);}.path-prefix.svelte-15jn9j3 {padding:0.75rem 0.5rem 0.75rem 0.75rem;background-color:#f3f4f6;color:#6b7280;font-weight:600;font-size:1rem;border-right:1px solid #d1d5db;}[data-theme="dark"] .path-prefix.svelte-15jn9j3 {background-color:#1f2937;color:#9ca3af;border-right-color:#374151;}.path-input.svelte-15jn9j3 {border:none !important;box-shadow:none !important;flex:1;}.path-input.svelte-15jn9j3:focus {outline:none;box-shadow:none !important;}.field-hint.svelte-15jn9j3 {font-size:0.75rem;color:#6b7280;font-style:italic;}[data-theme="dark"] .field-hint.svelte-15jn9j3 {color:#9ca3af;}.loading-indicator.svelte-15jn9j3 {text-align:center;padding:2rem;color:#6b7280;font-style:italic;}[data-theme="dark"] .loading-indicator.svelte-15jn9j3 {color:#9ca3af;}.substops-list.svelte-15jn9j3 {display:flex;flex-direction:column;gap:1.5rem;}.substop-group.svelte-15jn9j3 {border:1px solid #e5e7eb;border-radius:0.5rem;padding:1rem;background-color:#f9fafb;}[data-theme="dark"] .substop-group.svelte-15jn9j3 {background-color:#111827;border-color:#374151;}.substop-group-title.svelte-15jn9j3 {margin:0 0 0.75rem 0;font-size:1rem;font-weight:600;color:#111827;}[data-theme="dark"] .substop-group-title.svelte-15jn9j3 {color:#f9fafb;}.substop-options.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.75rem;}.substop-card.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.75rem;padding:0.75rem;border:2px solid #d1d5db;border-radius:0.375rem;cursor:pointer;transition:all 0.2s;background-color:white;}\n\n  @media (max-width: 640px) {.substop-card.svelte-15jn9j3 {gap:0.5rem;padding:0.5rem;}\n  }.substop-card.svelte-15jn9j3:hover {border-color:#087bc4;background-color:#f0f9ff;}.substop-card.selected.svelte-15jn9j3 {border-color:#087bc4;background-color:#dbeafe;}.substop-card.disabled.svelte-15jn9j3 {opacity:0.5;cursor:not-allowed;pointer-events:none;}[data-theme="dark"] .substop-card.svelte-15jn9j3 {background-color:#1f2937;border-color:#374151;}[data-theme="dark"] .substop-card.svelte-15jn9j3:hover {border-color:#60a5fa;background-color:#1e3a8a;}[data-theme="dark"] .substop-card.selected.svelte-15jn9j3 {border-color:#60a5fa;background-color:#1e40af;}.substop-card.svelte-15jn9j3 input[type="checkbox"]:where(.svelte-15jn9j3) {margin-top:0.25rem;cursor:pointer;flex-shrink:0;}.substop-name.svelte-15jn9j3 {font-weight:600;font-size:0.875rem;}.substop-id.svelte-15jn9j3 {font-family:monospace;font-size:0.7rem;color:#6b7280;background-color:#f3f4f6;padding:0.15rem 0.4rem;border-radius:0.25rem;}[data-theme="dark"] .substop-id.svelte-15jn9j3 {color:#9ca3af;background-color:#374151;}.substop-routes.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.4rem;}.routes-label.svelte-15jn9j3 {font-size:0.75rem;font-weight:500;color:#6b7280;}[data-theme="dark"] .routes-label.svelte-15jn9j3 {color:#9ca3af;}.route-list.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.35rem;}.route-row.svelte-15jn9j3 {display:flex;align-items:center;gap:0.5rem;font-size:0.85rem;}\n\n  @media (max-width: 640px) {.route-row.svelte-15jn9j3 {font-size:0.8rem;}\n  }.route-number.svelte-15jn9j3 {display:inline-flex;align-items:center;gap:0.35rem;font-weight:700;color:#1f2937;white-space:nowrap;}[data-theme="dark"] .route-number.svelte-15jn9j3 {color:#f3f4f6;}.route-icon.svelte-15jn9j3 {height:1em;width:auto;vertical-align:middle;flex-shrink:0;}.route-line-text.svelte-15jn9j3 {vertical-align:middle;}.route-dest.svelte-15jn9j3 {font-size:0.85rem;color:#6b7280;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}[data-theme="dark"] .route-dest.svelte-15jn9j3 {color:#9ca3af;}.no-routes.svelte-15jn9j3 {font-size:0.75rem;color:#9ca3af;font-style:italic;}.substops-context.svelte-15jn9j3 {padding:0.75rem;background-color:#f3f4f6;border-left:3px solid #087bc4;border-radius:0.25rem;margin-bottom:1rem;}[data-theme="dark"] .substops-context.svelte-15jn9j3 {background-color:#111827;border-left-color:#60a5fa;}.context-item.svelte-15jn9j3 {font-size:0.875rem;color:#374151;margin:0.25rem 0;}[data-theme="dark"] .context-item.svelte-15jn9j3 {color:#d1d5db;}.full-stop-checkbox.svelte-15jn9j3 {display:flex;align-items:center;gap:0.5rem;padding:0.5rem;margin-bottom:0.75rem;border:1px solid #d1d5db;border-radius:0.25rem;cursor:pointer;font-weight:500;}[data-theme="dark"] .full-stop-checkbox.svelte-15jn9j3 {border-color:#374151;}.full-stop-checkbox.svelte-15jn9j3 input[type="checkbox"]:where(.svelte-15jn9j3) {cursor:pointer;}.substop-checkbox-label.svelte-15jn9j3 {display:flex;align-items:flex-start;gap:0.5rem;cursor:pointer;flex:1;}.substop-checkbox-label.svelte-15jn9j3 input[type="checkbox"]:where(.svelte-15jn9j3) {margin-top:0.2rem;cursor:pointer;flex-shrink:0;}.substop-info.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.25rem;}.substop-title-input.svelte-15jn9j3 {padding:0.5rem;background-color:#f9fafb;border-radius:0.25rem;margin-top:0.5rem;}[data-theme="dark"] .substop-title-input.svelte-15jn9j3 {background-color:#1f2937;}.substop-title-input.svelte-15jn9j3 label:where(.svelte-15jn9j3) {display:block;font-size:0.75rem;font-weight:600;color:#6b7280;margin-bottom:0.25rem;}[data-theme="dark"] .substop-title-input.svelte-15jn9j3 label:where(.svelte-15jn9j3) {color:#9ca3af;}.substop-title-input.svelte-15jn9j3 input[type="text"]:where(.svelte-15jn9j3) {width:100%;padding:0.375rem 0.5rem;border:1px solid #d1d5db;border-radius:0.25rem;font-size:0.875rem;background-color:white;color:#111827;box-sizing:border-box;}[data-theme="dark"] .substop-title-input.svelte-15jn9j3 input[type="text"]:where(.svelte-15jn9j3) {background-color:#374151;border-color:#4b5563;color:#f3f4f6;}.substop-title-input.svelte-15jn9j3 input[type="text"]:where(.svelte-15jn9j3):focus {outline:none;border-color:#087bc4;box-shadow:0 0 0 3px rgba(8, 123, 196, 0.1);}.route-chip-small.svelte-15jn9j3 {display:inline-block;padding:0.1rem 0.4rem;background-color:#dbeafe;color:#0c4a6e;font-size:0.65rem;font-weight:600;border-radius:0.2rem;margin-right:0.25rem;}[data-theme="dark"] .route-chip-small.svelte-15jn9j3 {background-color:#1e3a8a;color:#93c5fd;}.mapping-item.svelte-15jn9j3 {padding:0.5rem;background-color:white;border-left:2px solid #087bc4;border-radius:0.25rem;margin-bottom:0.5rem;}[data-theme="dark"] .mapping-item.svelte-15jn9j3 {background-color:#374151;border-left-color:#60a5fa;}.mapping-routes.svelte-15jn9j3 {margin-top:0.25rem;display:flex;flex-wrap:wrap;gap:0.25rem;}.mappings-preview.svelte-15jn9j3 {margin-top:0.5rem;}.route-filter-list.svelte-15jn9j3 {display:flex;flex-direction:column;gap:1.5rem;}.route-filter-group.svelte-15jn9j3 {border:1px solid #e5e7eb;border-radius:0.5rem;padding:1rem;background-color:#f9fafb;}[data-theme="dark"] .route-filter-group.svelte-15jn9j3 {background-color:#111827;border-color:#374151;}.route-filter-title.svelte-15jn9j3 {margin:0 0 0.75rem 0;font-size:1rem;font-weight:600;color:#111827;}[data-theme="dark"] .route-filter-title.svelte-15jn9j3 {color:#f9fafb;}.route-filter-count.svelte-15jn9j3 {font-size:0.875rem;font-weight:400;color:#6b7280;margin-left:0.5rem;}[data-theme="dark"] .route-filter-count.svelte-15jn9j3 {color:#9ca3af;}.route-filter-options.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.5rem;}.route-filter-button.svelte-15jn9j3 {display:flex;align-items:center;gap:0.75rem;padding:0.75rem;border:2px solid #d1d5db;border-radius:0.375rem;background-color:white;cursor:pointer;transition:all 0.2s;text-align:left;}\n\n  @media (max-width: 640px) {.route-filter-button.svelte-15jn9j3 {gap:0.5rem;padding:0.625rem;}\n  }.route-filter-button.svelte-15jn9j3:hover {border-color:#087bc4;background-color:#f0f9ff;}.route-filter-button.selected.svelte-15jn9j3 {border-color:#087bc4;background-color:#dbeafe;}[data-theme="dark"] .route-filter-button.svelte-15jn9j3 {background-color:#1f2937;border-color:#374151;}[data-theme="dark"] .route-filter-button.svelte-15jn9j3:hover {border-color:#60a5fa;background-color:#1e3a8a;}[data-theme="dark"] .route-filter-button.selected.svelte-15jn9j3 {border-color:#60a5fa;background-color:#1e40af;}.route-filter-line.svelte-15jn9j3 {display:inline-flex;align-items:center;gap:0.5rem;font-weight:700;color:#1f2937;white-space:nowrap;min-width:4rem;}[data-theme="dark"] .route-filter-line.svelte-15jn9j3 {color:#f3f4f6;}.route-filter-dest.svelte-15jn9j3 {font-size:0.875rem;color:#6b7280;flex:1;}[data-theme="dark"] .route-filter-dest.svelte-15jn9j3 {color:#9ca3af;}.direction-mappings-list.svelte-15jn9j3 {display:flex;flex-direction:column;gap:2rem;}.direction-mappings-container.svelte-15jn9j3 {display:flex;flex-direction:column;gap:1rem;border:1px solid #e5e7eb;border-radius:0.5rem;padding:1rem;background-color:#fafafa;}[data-theme="dark"] .direction-mappings-container.svelte-15jn9j3 {background-color:#0f1419;border-color:#374151;}.direction-mappings-header.svelte-15jn9j3 {display:flex;justify-content:space-between;align-items:center;margin-bottom:0.5rem;}.direction-mappings-header.svelte-15jn9j3 h4:where(.svelte-15jn9j3) {margin:0;font-size:1.125rem;font-weight:600;}.button-add-group.svelte-15jn9j3 {padding:0.5rem 1rem;background-color:#10b981;color:white;border:none;border-radius:0.375rem;font-weight:500;cursor:pointer;transition:background-color 0.2s;font-size:0.875rem;}.button-add-group.svelte-15jn9j3:hover {background-color:#059669;}[data-theme="dark"] .button-add-group.svelte-15jn9j3 {background-color:#059669;}[data-theme="dark"] .button-add-group.svelte-15jn9j3:hover {background-color:#047857;}.direction-group-card.svelte-15jn9j3 {border:2px solid #e5e7eb;border-radius:0.5rem;padding:1rem;background-color:#f9fafb;}[data-theme="dark"] .direction-group-card.svelte-15jn9j3 {background-color:#111827;border-color:#374151;}.direction-group-header.svelte-15jn9j3 {display:flex;gap:0.5rem;margin-bottom:0.75rem;}.direction-group-title-input.svelte-15jn9j3 {flex:1;padding:0.75rem;border:1px solid #d1d5db;border-radius:0.375rem;font-size:1rem;font-weight:600;}.direction-group-title-input.svelte-15jn9j3:focus {outline:none;border-color:#087bc4;box-shadow:0 0 0 3px rgba(8, 123, 196, 0.1);}.direction-group-title-input.error.svelte-15jn9j3 {border-color:#ef4444;}.direction-group-title-input.error.svelte-15jn9j3:focus {border-color:#dc2626;box-shadow:0 0 0 3px rgba(239, 68, 68, 0.1);}.inline-error.svelte-15jn9j3 {color:#dc2626;font-size:0.875rem;margin:0.5rem 0 0 0;font-weight:500;}[data-theme="dark"] .direction-group-title-input.svelte-15jn9j3 {background:#1f2937;color:#f9fafb;border-color:#374151;}[data-theme="dark"] .direction-group-title-input.svelte-15jn9j3:focus {border-color:#60a5fa;box-shadow:0 0 0 3px rgba(96, 165, 250, 0.1);}[data-theme="dark"] .direction-group-title-input.error.svelte-15jn9j3 {border-color:#f87171;}[data-theme="dark"] .direction-group-title-input.error.svelte-15jn9j3:focus {border-color:#ef4444;box-shadow:0 0 0 3px rgba(248, 113, 113, 0.1);}[data-theme="dark"] .inline-error.svelte-15jn9j3 {color:#fca5a5;}.button-remove-group.svelte-15jn9j3 {background:#ef4444;color:white;border:none;border-radius:0.375rem;width:2.5rem;height:2.5rem;font-size:1.5rem;cursor:pointer;transition:background-color 0.2s;display:flex;align-items:center;justify-content:center;flex-shrink:0;}.button-remove-group.svelte-15jn9j3:hover {background-color:#dc2626;}[data-theme="dark"] .button-remove-group.svelte-15jn9j3 {background-color:#dc2626;}[data-theme="dark"] .button-remove-group.svelte-15jn9j3:hover {background-color:#b91c1c;}.direction-group-routes.svelte-15jn9j3 {display:flex;flex-direction:column;gap:0.5rem;}.routes-select-label.svelte-15jn9j3 {margin:0;font-size:0.875rem;font-weight:500;color:#6b7280;}[data-theme="dark"] .routes-select-label.svelte-15jn9j3 {color:#9ca3af;}'
};

export default function ConfigWizard($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	// Removed unused errorMessage and errorTimeout for lint compliance
	let isLoadingSubStops = $.state(false);

	let searchError = $.state(null);
	let filterRoutesError = $.state(null);
	let selectedCount = $.state(0);
	let configTarget = $.state("");
	let currentRoutePath = $.state("");
	let newRouteTitle = $.state("");
	let newRoutePath = $.state("");
	let selectFullStop = $.state(false);
	let searchQuery = $.state("");
	let isSearching = $.state(false);
	let searchResults = $.state($.proxy([]));

	// eslint-disable-next-line svelte/no-unnecessary-state-wrap -- SvelteSet needs $state wrapper for reassignments
	let selectedStops = $.state($.proxy(new SvelteSet()));

	// eslint-disable-next-line svelte/no-unnecessary-state-wrap -- SvelteMap needs $state wrapper for reassignments
	let selectedSubStops = $.state($.proxy(new SvelteMap()));

	// eslint-disable-next-line svelte/no-unnecessary-state-wrap -- SvelteMap needs $state wrapper for reassignments
	let subStopRoutes = $.state($.proxy(new SvelteMap()));

	// eslint-disable-next-line svelte/no-unnecessary-state-wrap -- SvelteMap needs $state wrapper for reassignments
	let filterSelectedRoutes = $.state($.proxy(new SvelteMap()));

	// Direction mappings: Map<subStopId, Array<{title: string, routes: string[]}>>
	// eslint-disable-next-line svelte/no-unnecessary-state-wrap -- SvelteMap needs $state wrapper for reassignments
	let directionMappings = $.state($.proxy(new SvelteMap()));

	let currentStep = $.state("target");

	function normalizeRoutePath(path) {
		if (!path) {
			return "";
		}

		return path.startsWith("/") ? path : `/${path}`;
	}

	function isOnTheRunRoute(path) {
		return path === "on-the-run" || path === "/on-the-run";
	}

	function getTargetRoutePath() {
		if ($.get(configTarget) === "current") {
			return normalizeRoutePath($.get(currentRoutePath));
		}

		if ($.get(configTarget) === "route") {
			return normalizeRoutePath($.get(newRoutePath));
		}

		return "";
	}

	function isSubStopDisabled(subStopId) {
		// In the substops step, disable sub-stops that are already configured
		// in the CURRENT target route to prevent duplicates
		if ($.get(configTarget) === "main") {
			return ($$props.routeStopIdsByPath["/"] ?? []).includes(subStopId);
		}

		const routePath = getTargetRoutePath();

		if (!routePath) {
			return false;
		}

		const routeStops = $$props.routeStopIdsByPath[routePath] ?? [];

		return routeStops.includes(subStopId);
	}

	onMount(() => {
		// Get current route from hash-based routing (e.g., /#/hochaeckerstrasse)
		const hash = window.location.hash;

		// Hash format: #/routename or just # for main
		if (hash.length > 1) {
			$.set(
				currentRoutePath,
				hash.substring(1), // Remove the # prefix, keep everything after
				true
			);

			if ($.get(currentRoutePath) === "/" || $.get(currentRoutePath) === "") {
				$.set(currentRoutePath, "" // Clear if it's just the main route
				);
			}
		}

		// Preselect the current route unless it's on-the-run
		if ($.get(currentRoutePath) && !$$props.onTheRunDisabled && !isOnTheRunRoute($.get(currentRoutePath))) {
			$.set(configTarget, "current");
		} else {
			$.set(configTarget, "main");
		}

		// Add global keyboard event listener
		const handleGlobalKeydown = (event) => {
			handleKeydown(event);
		};

		window.addEventListener("keydown", handleGlobalKeydown);

		return () => {
			window.removeEventListener("keydown", handleGlobalKeydown);
		};
	});

	async function handleSearch() {
		if (!$.get(searchQuery).trim()) return;

		$.set(isSearching, true);
		$.set(searchError, null);

		try {
			// Call MVG's public API endpoint directly
			// Base: https://www.mvg.de/api/bgw-pt/v3
			// Endpoint: /locations?query=...&locationTypes=STATION
			const params = new globalThis.URLSearchParams({ query: $.get(searchQuery).trim(), locationTypes: "STATION" });

			const response = await fetch(`https://www.mvg.de/api/bgw-pt/v3/locations?${params.toString()}`);
			const data = await response.json();

			if (Array.isArray(data) && data.length > 0) {
				$.set(
					searchResults,
					data.map((result) => {
						// Check if this result has sub-stops (physical stops)
						const subStops = [];

						if (result.children && Array.isArray(result.children)) {
							subStops.push(...result.children.map((child) => ({
								id: child.globalId,
								name: child.name,
								place: child.place || result.place || "Munich",
								type: child.type,
								parentId: result.globalId
							})));
						}

						return {
							id: result.globalId,
							name: result.name,
							place: result.place || "Munich",
							type: result.type,
							subStops
						};
					}),
					true
				);

				$.set(currentStep, "select");
			} else {
				$.set(searchError, "No stops found");
			}
		} catch(error) {
			$.set(searchError, error instanceof Error ? error.message : "Failed to search stations", true);
			console.error("Search error:", error);
		} finally {
			$.set(isSearching, false);
		}
	}

	function handleSelectStop(stopId) {
		if ($.get(selectedStops).has(stopId)) {
			$.get(selectedStops).delete(stopId);
		} else {
			$.get(selectedStops).add(stopId);
		}

		$.set(selectedCount, $.get(selectedStops).size, true);
	}

	/** Extract platform/stop number from ID (e.g. de:09162:1129:9:9 → "9"). */
	function extractStopNumberFromId(stopId) {
		const parts = stopId.split(":");
		const last = parts[parts.length - 1];

		return last && (/^\d+$/).test(last) ? last : null;
	}

	function getDefaultSubStopTitle(subStopId, platformValue, platformKind) {
		if (platformValue !== undefined && platformValue !== null && `${platformValue}`.trim() !== "") {
			if (platformKind === "platform") {
				return `Platform ${platformValue}`;
			}

			if (platformKind === "stop") {
				return `Stop ${platformValue}`;
			}
		}

		// Fallback: extract from stop ID when API doesn't provide platform (e.g. de:09162:1129:9:9 → "Stop 9")
		const extracted = extractStopNumberFromId(subStopId);

		return extracted ? `Stop ${extracted}` : "Stop";
	}

	function getSubStopTitleForDisplay(subStopId, title, platformValue, platformKind) {
		const defaultTitle = getDefaultSubStopTitle(subStopId, platformValue, platformKind);

		if (!title) return defaultTitle;

		if ((/^(stop|platform)\s+\d+$/i).test(title) && title !== defaultTitle) {
			return defaultTitle;
		}

		return title;
	}

	function handleSelectSubStop(
		subStopId,
		subStopName,
		platformValue,
		platformKind,
		parentStopId
	) {
		if (isSubStopDisabled(subStopId)) {
			return;
		}

		if ($.get(selectedSubStops).has(subStopId)) {
			$.get(selectedSubStops).delete(subStopId);
		} else {
			// Auto-generate title from stop ID (e.g., "Stop 2" from "de:09162:1108:2:2")
			const defaultTitle = getDefaultSubStopTitle(subStopId, platformValue, platformKind);

			$.get(selectedSubStops).set(subStopId, {
				id: subStopId,
				title: defaultTitle,
				platformValue,
				platformKind,
				parentStopId
			});

			// When selecting a sub-stop, also add its parent stop to the main selection
			// so both the parent and child are configured
			if (parentStopId && !$.get(selectedStops).has(parentStopId)) {
				$.get(selectedStops).add(parentStopId);
				$.set(selectedCount, $.get(selectedStops).size, true);
			}
		}
	}

	function updateSubStopTitle(subStopId, title) {
		const entry = $.get(selectedSubStops).get(subStopId);

		if (entry) {
			$.get(selectedSubStops).set(subStopId, { ...entry, title });
		}
	}

	async function proceedToSubStops() {
		if ($.get(selectedStops).size === 0) return;

		// Load route information and discover substops from departure data
		$.set(isLoadingSubStops, true);

		$.set(currentStep, "substops");

		try {
			const allSubStops = new SvelteMap(); // SvelteMap of parent stop ID to its substops

			for (const stopId of Array.from($.get(selectedStops))) {
				const stop = $.get(searchResults).find((r) => r.id === stopId);

				if (!stop) continue;

				console.log('Fetching departures for:', stop.name, stopId);

				// Fetch departures to discover physical stops
				const subStopsData = await fetchSubStopsFromDepartures(stopId, stop.name);

				if (subStopsData.length > 0) {
					allSubStops.set(stopId, { mainStop: stop, subStops: subStopsData });

					// Now update the search results to include these substops
					const resultIndex = $.get(searchResults).findIndex((r) => r.id === stopId);

					if (resultIndex >= 0) {
						$.get(searchResults)[resultIndex] = { ...$.get(searchResults)[resultIndex], subStops: subStopsData };
					}
				}
			}

			console.log('Discovered substops:', allSubStops);

			// Show substops step if we found any
			if (allSubStops.size > 0) {
				return;
			}

			// No platforms to choose between: the stops are configured whole. Without
			// this the wizard would finish and add nothing.
			console.log('No substops found, configuring the stops whole');

			$.set(selectFullStop, true);
			$.set(currentStep, "configure");
		} catch(error) {
			console.error("Error loading substop routes:", error);
			$.set(selectFullStop, true // A failed lookup must not swallow the stops
			);
			$.set(currentStep, "configure" // Fallback to configure on error
			);
		} finally {
			$.set(isLoadingSubStops, false);
		}
	}

	async function fetchSubStopsFromDepartures(stopId, stopName) {
		try {
			const repo = new MvgDepartureRepository();
			const departures = await repo.getDepartures(stopId, { limit: 100 });

			// Extract unique physical stops from departures
			const physicalStops = new SvelteMap();

			for (const departure of departures) {
				// Use stopPointGlobalId from departure - if empty/null, fall back to main stop ID
				const physicalStopId = departure.stopPointGlobalId || stopId;

				const platformValue = departure.platform;
				const platformKind = platformValue ? "platform" : null;

				if (!physicalStops.has(physicalStopId)) {
					physicalStops.set(physicalStopId, {
						id: physicalStopId,
						name: stopName, // Use main stop name for all
						parentId: stopId,
						platformValue,
						platformKind,
						routes: []
					});
				} else {
					// Update existing stop if we now have better platform info
					const existing = physicalStops.get(physicalStopId);

					if (platformValue && !existing.platformValue) {
						existing.platformValue = platformValue;
						existing.platformKind = platformKind;
					}
				}

				// Add route info
				const stop = physicalStops.get(physicalStopId);

				const routeKey = `${departure.line} ${departure.destination}`;

				if (!stop.routes.some((r) => `${r.line} ${r.destination}` === routeKey)) {
					stop.routes.push({
						line: departure.line,
						destination: departure.destination,
						transportType: departure.transportType.toUpperCase().replace(/[-\s]/g, '_')
					});
				}
			}

			// Filter to only show substops with real unique IDs from the API
			const subStops = Array.from(physicalStops.values()).filter((stop) => {
				if (stop.id === stopId) return false; // Exclude main stop itself
				if (stop.id.includes(':platform:')) return false; // Exclude synthetic IDs

				return true;
			});

			console.log(`Found ${subStops.length} physical stops with platform info:`, subStops.map((s) => ({
				id: s.id,
				name: s.name,
				platformValue: s.platformValue,
				platformKind: s.platformKind,
				routes: s.routes.length
			})));

			// Store routes for each substop
			for (const subStop of subStops) {
				$.get(subStopRoutes).set(subStop.id, subStop.routes);
			}

			// Also collect ALL unique routes for the main stop (from all physical stops)
			const mainStopRoutes = [];

			const mainStopRouteKeys = new SvelteSet();

			for (const stop of physicalStops.values()) {
				for (const route of stop.routes) {
					const routeKey = `${route.line} ${route.destination}`;

					if (!mainStopRouteKeys.has(routeKey)) {
						mainStopRouteKeys.add(routeKey);
						mainStopRoutes.push(route);
					}
				}
			}

			$.get(subStopRoutes).set(stopId, mainStopRoutes);
			console.log(`Stored ${mainStopRoutes.length} unique routes for main stop ${stopId}`);
			console.log(`Found ${subStops.length} physical stops for ${stopName}:`, subStops);

			// Only return substops if there's more than one physical stop
			return subStops.length > 1 ? subStops : [];
		} catch(error) {
			console.error(`Error fetching departures for ${stopId}:`, error);

			return [];
		}
	}

	function validateDirectionMappings() {
		// Validate all direction mapping groups have titles and at least one route
		const stopIdsToCheck = new SvelteSet();

		// Add main stop if full stop is selected
		if ($.get(selectFullStop)) {
			$.get(selectedStops).forEach((id) => stopIdsToCheck.add(id));
		}

		// Add all substops
		$.get(selectedSubStops).forEach((_, id) => stopIdsToCheck.add(id));

		for (const stopId of stopIdsToCheck) {
			const groups = $.get(directionMappings).get(stopId);

			if (groups && groups.length > 0) {
				for (let i = 0; i < groups.length; i++) {
					const group = groups[i];

					if (!group.title || group.title.trim() === "") {
						return `Direction group ${i + 1} has no title. Please provide a title or remove the empty group.`;
					}

					if (group.routes.length === 0) {
						return `Direction group "${group.title}" has no routes selected. Please select at least one route or remove the group.`;
					}
				}
			}
		}

		return null;
	}

	async function proceedToConfiguration() {
		if ($.get(selectedStops).size === 0) return;

		// Validate direction mappings if they exist
		const validationError = validateDirectionMappings();

		if (validationError) {
			$.set(filterRoutesError, validationError, true);

			return;
		}

		$.set(filterRoutesError, null);
		$.set(currentStep, "configure");
	}

	function proceedToRouteFiltering() {
		// Show route filtering if we have substops with routes OR if full stop is selected
		const hasSubStopsWithRoutes = Array.from($.get(selectedSubStops).keys()).some((subStopId) => {
			const routes = $.get(subStopRoutes).get(subStopId) || [];

			return routes.length > 0;
		});

		if (hasSubStopsWithRoutes || $.get(selectFullStop)) {
			$.set(currentStep, "filter-routes");
		} else {
			$.set(currentStep, "configure");
		}
	}

	/** Unique key for a route: line|destination. Backend filters by line only. */
	function buildRouteKey(line, destination) {
		return `${line}|${destination}`;
	}

	/** Extract line from routeKey (handles both "62" and "62|Marienplatz" formats). */
	function routeKeyToLine(routeKey) {
		return routeKey.includes("|") ? routeKey.split("|")[0] : routeKey;
	}

	function toggleRouteFilter(subStopId, routeKey) {
		if (!$.get(filterSelectedRoutes).has(subStopId)) {
			$.get(filterSelectedRoutes).set(subStopId, new SvelteSet());
		}

		const routeSet = $.get(filterSelectedRoutes).get(subStopId);

		if (routeSet.has(routeKey)) {
			routeSet.delete(routeKey);
		} else {
			routeSet.add(routeKey);
		}
	}

	function addDirectionGroup(stopId) {
		if (!$.get(directionMappings).has(stopId)) {
			$.get(directionMappings).set(stopId, []);
		}

		const groups = $.get(directionMappings).get(stopId);

		groups.push({ title: "", routes: [] });
		$.get(directionMappings // Trigger reactivity
		).set(stopId, [...groups]);
	}

	function removeDirectionGroup(stopId, groupIndex) {
		const groups = $.get(directionMappings).get(stopId);

		if (groups) {
			groups.splice(groupIndex, 1);
			$.get(directionMappings // Trigger reactivity
			).set(stopId, [...groups]);
			$.set(filterRoutesError, null // Clear validation error
			);
		}
	}

	function updateDirectionGroupTitle(stopId, groupIndex, title) {
		const groups = $.get(directionMappings).get(stopId);

		if (groups && groups[groupIndex]) {
			groups[groupIndex].title = title;
			$.get(directionMappings // Trigger reactivity
			).set(stopId, [...groups]);
			$.set(filterRoutesError, null // Clear validation error
			);
		}
	}

	function toggleRouteInGroup(stopId, groupIndex, routeKey) {
		const groups = $.get(directionMappings).get(stopId);

		if (groups && groups[groupIndex]) {
			const group = groups[groupIndex];
			const routeIndex = group.routes.indexOf(routeKey);

			// Create new routes array with the toggle applied
			const newRoutes = routeIndex >= 0
				? group.routes.filter((_, i) => i !== routeIndex)
				: // Remove
				[...group.routes, routeKey]; // Add

			// Create new group object and new groups array for reactivity
			const newGroups = groups.map((g, i) => i === groupIndex ? { ...g, routes: newRoutes } : g);

			$.get(directionMappings).set(stopId, newGroups);
			$.set(filterRoutesError, null // Clear validation error
			);
		}
	}

	function resetWizard() {
		$.set(currentStep, "target");
		$.set(searchQuery, "");
		$.set(searchResults, [], true);
		$.set(selectedStops, new SvelteSet(), true);
		$.set(selectedSubStops, new SvelteMap(), true);
		$.set(subStopRoutes, new SvelteMap(), true);
		$.set(filterSelectedRoutes, new SvelteMap(), true);
		$.set(directionMappings, new SvelteMap(), true);
		$.set(selectFullStop, false);
		$.set(newRouteTitle, "");
		$.set(newRoutePath, "");
		$.set(selectedCount, 0);
	}

	async function handleComplete() {
		const stopsConfig = [];

		console.log("=== WIZARD HANDLECOMPLETE ===");
		console.log("configTarget:", $.get(configTarget));
		console.log("selectFullStop:", $.get(selectFullStop));
		console.log("selectedStops:", Array.from($.get(selectedStops)));
		console.log("selectedSubStops:", Array.from($.get(selectedSubStops).entries()));

		for (const stopId of Array.from($.get(selectedStops))) {
			const stop = $.get(searchResults).find((r) => r.id === stopId);

			// If full stop is selected, add the MAIN stop itself first
			if ($.get(selectFullStop)) {
				console.log(`Adding main stop: ${stopId}`);

				const mainConfig = {
					station_id: stopId,
					station_name: stop?.name || stopId,
					max_departures_per_stop: 4,
					max_departures_per_route: 2,
					max_hours_in_advance: 3
				};

				// Check if user created direction mappings for the main stop
				const mainMappings = $.get(directionMappings).get(stopId);

				if (mainMappings && mainMappings.length > 0) {
					const directionMappingsObj = {};

					for (const group of mainMappings) {
						if (group.title && group.routes.length > 0) {
							directionMappingsObj[group.title] = group.routes;
						}
					}

					if (Object.keys(directionMappingsObj).length > 0) {
						mainConfig.direction_mappings = directionMappingsObj;
						mainConfig.show_ungrouped = false;
					} else {
						mainConfig.show_ungrouped = true;
					}
				} else {
					mainConfig.show_ungrouped = true;
				}

				stopsConfig.push(mainConfig);
			}

			// Add individual sub-stops that belong to this parent stop
			for (const [subStopId, subStopData] of $.get(selectedSubStops).entries()) {
				// Only add if this sub-stop belongs to the current stop (or no parent specified)
				if (subStopData.parentStopId && subStopData.parentStopId !== stopId) {
					continue;
				}

				// Use the actual platform/stop label as the default title (Stop X / Platform Y)
				const defaultLabel = getDefaultSubStopTitle(subStopId, subStopData.platformValue, subStopData.platformKind);

				const displayTitle = subStopData.title !== defaultLabel ? subStopData.title : undefined;
				const ungroupedTitle = displayTitle ?? defaultLabel;

				console.log(`Adding sub-stop: ${subStopId} (parent: ${subStopData.parentStopId}) with title: "${ungroupedTitle}"`);

				const config = {
					station_id: subStopId,
					station_name: stop?.name || stopId,
					max_departures_per_stop: 4,
					max_departures_per_route: 2,
					max_hours_in_advance: 3,
					custom_title: String(ungroupedTitle)
				};

				// If full stop is selected, use direction_mappings; otherwise use platform_filter_routes
				if ($.get(selectFullStop)) {
					// Add direction_mappings if user created groups for this substop
					const mappings = $.get(directionMappings).get(subStopId);

					if (mappings && mappings.length > 0) {
						const directionMappingsObj = {};

						for (const group of mappings) {
							if (group.title && group.routes.length > 0) {
								directionMappingsObj[group.title] = group.routes;
							}
						}

						if (Object.keys(directionMappingsObj).length > 0) {
							config.direction_mappings = directionMappingsObj;

							// When we have direction mappings configured, turn off ungrouped routes
							config.show_ungrouped = false;
						} else {
							// No valid mappings, show ungrouped
							config.show_ungrouped = true;
						}
					} else {
						// No mappings at all, show ungrouped
						config.show_ungrouped = true;
					}
				} else {
					// Individual platforms show ungrouped departures
					config.show_ungrouped = true;

					// Add platform_filter_routes if user selected specific routes to filter
					const selectedRoutes = $.get(filterSelectedRoutes).get(subStopId);

					if (selectedRoutes && selectedRoutes.size > 0) {
						config.platform_filter_routes = [...new Set(Array.from(selectedRoutes).map(routeKeyToLine))];
					}
				}

				stopsConfig.push(config);
			}
		}

		console.log("Final stopsConfig being sent to merge:", stopsConfig);

		const wizardResult = {
			target: $.get(configTarget) === "main" ? "main" : "route",
			...$.get(configTarget) !== "main" && {
				route: {
					path: getTargetRoutePath() || "/",
					title: $.get(newRouteTitle)
				}
			},
			stops: stopsConfig
		};

		await $$props.onComplete(wizardResult);
		resetWizard();
	}

	function handleKeydown(event) {
		// Ignore keypresses if user is typing in an input field
		const target = event.target;

		if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
			// Let Enter work in the search input
			if (event.key === "Enter" && $.get(currentStep) === "search" && target.classList.contains("search-input")) {
				handleSearch();

				return;
			}

			// Let Enter work in route-details inputs
			if (event.key === "Enter" && $.get(currentStep) === "route-details") {
				if ($.get(newRouteTitle).trim() && $.get(newRoutePath).trim()) {
					$.set(currentStep, "search");
					event.preventDefault();
				}

				return;
			}

			return;
		}

		if (event.key === "Escape") {
			$$props.onCancel();

			return;
		}

		if (event.key === "Enter") {
			// Handle Enter key to proceed to next step
			if ($.get(currentStep) === "target") {
				if ($.get(configTarget) === "route") {
					$.set(currentStep, "route-details");
				} else if ($.get(configTarget)) {
					$.set(currentStep, "search");
				}
			} else if ($.get(currentStep) === "route-details") {
				if ($.get(newRouteTitle).trim() && $.get(newRoutePath).trim()) {
					$.set(currentStep, "search");
				}
			} else if ($.get(currentStep) === "search") {
				if (!$.get(isSearching) && $.get(searchQuery).trim()) {
					handleSearch();
				}
			} else if ($.get(currentStep) === "select") {
				if ($.get(selectedCount) > 0) {
					proceedToSubStops();
				}
			} else if ($.get(currentStep) === "substops") {
				if (!$.get(isLoadingSubStops)) {
					proceedToRouteFiltering();
				}
			} else if ($.get(currentStep) === "filter-routes") {
				proceedToConfiguration();
			} else if ($.get(currentStep) === "configure") {
				handleComplete();
			}

			event.preventDefault();
		}
	}

	var div = root_54();
	var div_1 = $.child(div);
	var div_2 = $.child(div_1);
	var button = $.sibling($.child(div_2), 2);

	$.reset(div_2);

	var div_3 = $.sibling(div_2, 2);
	var node = $.child(div_3);

	{
		var consequent_1 = ($$anchor) => {
			var div_4 = root_1();
			var div_5 = $.sibling($.child(div_4), 4);
			var button_1 = $.child(div_5);
			let classes;
			var node_1 = $.sibling(button_1, 2);

			{
				var consequent = ($$anchor) => {
					var button_2 = root();
					let classes_1;
					var div_6 = $.child(button_2);
					var text = $.only_child(div_6, true);

					$.next(2);
					$.reset(button_2);

					$.template_effect(
						($0) => {
							classes_1 = $.set_class(button_2, 1, 'target-button svelte-15jn9j3', null, classes_1, { active: $.get(configTarget) === "current" });
							$.set_text(text, $0);
						},
						[() => $.get(currentRoutePath).replace(/^\//, "")]
					);

					$.delegated('click', button_2, () => {
						$.set(configTarget, "current");
						$.set(currentStep, "search");
					});

					$.append($$anchor, button_2);
				};

				var d = $.derived(() => $.get(currentRoutePath) && !isOnTheRunRoute($.get(currentRoutePath)) && !$$props.onTheRunDisabled);

				$.if(node_1, ($$render) => {
					if ($.get(d)) $$render(consequent);
				});
			}

			var button_3 = $.sibling(node_1, 2);
			let classes_2;

			$.reset(div_5);
			$.reset(div_4);

			$.template_effect(() => {
				classes = $.set_class(button_1, 1, 'target-button svelte-15jn9j3', null, classes, { active: $.get(configTarget) === "main" });
				classes_2 = $.set_class(button_3, 1, 'target-button target-button-new svelte-15jn9j3', null, classes_2, { active: $.get(configTarget) === "route" });
			});

			$.delegated('click', button_1, () => {
				$.set(configTarget, "main");
				$.set(currentStep, "search");
			});

			$.delegated('click', button_3, () => {
				$.set(configTarget, "route");
				$.set(currentStep, "route-details");
			});

			$.append($$anchor, div_4);
		};

		var consequent_2 = ($$anchor) => {
			var div_7 = root_2();
			var div_8 = $.sibling($.child(div_7), 4);
			var div_9 = $.child(div_8);
			var input_1 = $.sibling($.child(div_9), 2);

			$.remove_input_defaults(input_1);
			$.autofocus(input_1, true);
			$.next(2);
			$.reset(div_9);

			var div_10 = $.sibling(div_9, 2);
			var div_11 = $.sibling($.child(div_10), 2);
			var input_2 = $.sibling($.child(div_11), 2);

			$.remove_input_defaults(input_2);
			$.reset(div_11);

			var span = $.sibling(div_11, 2);
			var text_1 = $.only_child(span);

			$.reset(div_10);
			$.reset(div_8);
			$.reset(div_7);
			$.template_effect(() => $.set_text(text_1, `URL slug (lowercase, hyphens only). Full URL: /#/${($.get(newRoutePath) || 'yourpath') ?? ''}`));
			$.bind_value(input_1, () => $.get(newRouteTitle), ($$value) => $.set(newRouteTitle, $$value));

			$.delegated('input', input_2, (e) => {
				// Auto-sanitize: lowercase, replace spaces with hyphens, remove special chars
				const input = e.currentTarget;

				input.value = input.value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
				$.set(newRoutePath, input.value, true);
			});

			$.bind_value(input_2, () => $.get(newRoutePath), ($$value) => $.set(newRoutePath, $$value));
			$.append($$anchor, div_7);
		};

		var consequent_6 = ($$anchor) => {
			var div_12 = root_7();
			var div_13 = $.sibling($.child(div_12), 4);
			var input_3 = $.child(div_13);

			$.remove_input_defaults(input_3);
			$.autofocus(input_3, true);

			var button_4 = $.sibling(input_3, 2);
			var text_2 = $.only_child(button_4, true);

			$.reset(div_13);

			var node_2 = $.sibling(div_13, 2);

			{
				var consequent_3 = ($$anchor) => {
					var div_14 = root_3();
					var text_3 = $.only_child(div_14, true);

					$.template_effect(() => $.set_text(text_3, $.get(searchError)));
					$.append($$anchor, div_14);
				};

				$.if(node_2, ($$render) => {
					if ($.get(searchError)) $$render(consequent_3);
				});
			}

			var node_3 = $.sibling(node_2, 2);

			{
				var consequent_5 = ($$anchor) => {
					var div_15 = root_6();
					var p = $.child(div_15);
					var text_4 = $.only_child(p);
					var node_4 = $.sibling(p, 2);

					$.each(node_4, 17, () => $.get(searchResults), (result) => result.id, ($$anchor, result) => {
						var div_16 = root_5();
						var span_1 = $.child(div_16);
						var strong = $.child(span_1);
						var text_5 = $.only_child(strong, true);
						var node_5 = $.sibling(strong, 2);

						{
							var consequent_4 = ($$anchor) => {
								var span_2 = root_4();
								var text_6 = $.only_child(span_2);

								$.template_effect(() => $.set_text(text_6, `• ${$.get(result).place ?? ''}`));
								$.append($$anchor, span_2);
							};

							$.if(node_5, ($$render) => {
								if ($.get(result).place) $$render(consequent_4);
							});
						}

						$.reset(span_1);

						var span_3 = $.sibling(span_1, 2);
						var text_7 = $.only_child(span_3, true);

						$.reset(div_16);

						$.template_effect(() => {
							$.set_text(text_5, $.get(result).name);
							$.set_text(text_7, $.get(result).id);
						});

						$.append($$anchor, div_16);
					});

					$.reset(div_15);
					$.template_effect(() => $.set_text(text_4, `Found ${$.get(searchResults).length ?? ''} stop(s):`));
					$.append($$anchor, div_15);
				};

				$.if(node_3, ($$render) => {
					if ($.get(searchResults).length > 0) $$render(consequent_5);
				});
			}

			$.reset(div_12);

			$.template_effect(
				($0) => {
					input_3.disabled = $.get(isSearching);
					button_4.disabled = $0;
					$.set_text(text_2, $.get(isSearching) ? "Searching..." : "Search");
				},
				[() => $.get(isSearching) || !$.get(searchQuery).trim()]
			);

			$.delegated('keydown', input_3, (e) => {
				if (e.key === "Enter") handleSearch();
			});

			$.bind_value(input_3, () => $.get(searchQuery), ($$value) => $.set(searchQuery, $$value));
			$.delegated('click', button_4, handleSearch);
			$.append($$anchor, div_12);
		};

		var consequent_8 = ($$anchor) => {
			var div_17 = root_10();
			var div_18 = $.sibling($.child(div_17), 6);

			$.each(div_18, 21, () => $.get(searchResults), (stop) => stop.id, ($$anchor, stop) => {
				var label = root_9();
				var input_4 = $.child(label);

				$.remove_input_defaults(input_4);

				var span_4 = $.sibling(input_4, 2);
				var strong_1 = $.child(span_4);
				var text_8 = $.only_child(strong_1, true);
				var span_5 = $.sibling(strong_1, 2);
				var node_6 = $.child(span_5);

				{
					var consequent_7 = ($$anchor) => {
						var span_6 = root_8();
						var text_9 = $.only_child(span_6, true);

						$.template_effect(() => $.set_text(text_9, $.get(stop).place));
						$.append($$anchor, span_6);
					};

					$.if(node_6, ($$render) => {
						if ($.get(stop).place) $$render(consequent_7);
					});
				}

				var span_7 = $.sibling(node_6, 2);
				var text_10 = $.only_child(span_7, true);

				$.reset(span_5);
				$.reset(span_4);
				$.reset(label);

				$.template_effect(
					($0) => {
						$.set_checked(input_4, $0);
						$.set_text(text_8, $.get(stop).name);
						$.set_text(text_10, $.get(stop).id);
					},
					[() => $.get(selectedStops).has($.get(stop).id)]
				);

				$.delegated('change', input_4, () => handleSelectStop($.get(stop).id));
				$.append($$anchor, label);
			});

			$.reset(div_18);
			$.reset(div_17);
			$.append($$anchor, div_17);
		};

		var consequent_19 = ($$anchor) => {
			var div_19 = root_26();
			var node_7 = $.sibling($.child(div_19), 4);

			{
				var consequent_9 = ($$anchor) => {
					var div_20 = root_11();

					$.append($$anchor, div_20);
				};

				var alternate_2 = ($$anchor) => {
					var fragment = root_25();
					var div_21 = $.first_child(fragment);

					$.each(div_21, 20, () => Array.from($.get(selectedStops)), (stopId) => stopId, ($$anchor, stopId) => {
						const mainStop = $.derived(() => $.get(searchResults).find((s) => s.id === stopId));
						var fragment_1 = $.comment();
						var node_8 = $.first_child(fragment_1);

						{
							var consequent_10 = ($$anchor) => {
								var div_22 = root_12();
								var strong_2 = $.child(div_22);
								var text_11 = $.only_child(strong_2, true);
								var text_12 = $.sibling(strong_2);

								$.reset(div_22);

								$.template_effect(() => {
									$.set_text(text_11, $.get(mainStop).name);
									$.set_text(text_12, ` (${$.get(mainStop).id ?? ''})`);
								});

								$.append($$anchor, div_22);
							};

							$.if(node_8, ($$render) => {
								if ($.get(mainStop)) $$render(consequent_10);
							});
						}

						$.append($$anchor, fragment_1);
					});

					$.reset(div_21);

					var div_23 = $.sibling(div_21, 2);

					$.each(div_23, 20, () => Array.from($.get(selectedStops)), (stopId) => stopId, ($$anchor, stopId) => {
						const mainStop = $.derived(() => $.get(searchResults).find((s) => s.id === stopId));
						var fragment_2 = $.comment();
						var node_9 = $.first_child(fragment_2);

						{
							var consequent_17 = ($$anchor) => {
								var div_24 = root_23();
								var h4 = $.child(div_24);
								var text_13 = $.only_child(h4, true);
								var label_1 = $.sibling(h4, 2);
								var input_5 = $.child(label_1);

								$.remove_input_defaults(input_5);
								$.next(2);
								$.reset(label_1);

								var div_25 = $.sibling(label_1, 2);

								$.each(
									div_25,
									21,
									() => $.get(mainStop).subStops.toSorted((a, b) => {
										const aVal = typeof a.platformValue === 'number'
											? a.platformValue
											: typeof a.platformValue === 'string' ? parseInt(a.platformValue) || 0 : 0;

										const bVal = typeof b.platformValue === 'number'
											? b.platformValue
											: typeof b.platformValue === 'string' ? parseInt(b.platformValue) || 0 : 0;

										return aVal - bVal;
									}),
									(subStop) => subStop.id,
									($$anchor, subStop) => {
										const routes = $.derived(() => $.get(subStopRoutes).get($.get(subStop).id) || []);
										const isSelected = $.derived(() => $.get(selectedSubStops).has($.get(subStop).id));
										const subStopData = $.derived(() => $.get(selectedSubStops).get($.get(subStop).id));
										const isDisabled = $.derived(() => isSubStopDisabled($.get(subStop).id));
										var div_26 = root_22();
										let classes_3;
										var label_2 = $.child(div_26);
										var input_6 = $.child(label_2);

										$.remove_input_defaults(input_6);

										var span_8 = $.sibling(input_6, 2);
										var span_9 = $.child(span_8);
										var text_14 = $.only_child(span_9);
										var span_10 = $.sibling(span_9, 2);
										var text_15 = $.only_child(span_10, true);

										$.reset(span_8);
										$.reset(label_2);

										var node_10 = $.sibling(label_2, 2);

										{
											var consequent_11 = ($$anchor) => {
												var div_27 = root_13();
												var label_3 = $.child(div_27);
												var input_7 = $.sibling(label_3, 2);

												$.remove_input_defaults(input_7);
												$.reset(div_27);

												$.template_effect(() => {
													$.set_attribute(label_3, 'for', `title-${$.get(subStop).id ?? ''}`);
													$.set_attribute(input_7, 'id', `title-${$.get(subStop).id ?? ''}`);
													$.set_value(input_7, $.get(subStopData)?.title || "");
												});

												$.delegated('change', input_7, (e) => updateSubStopTitle($.get(subStop).id, e.currentTarget.value));
												$.append($$anchor, div_27);
											};

											$.if(node_10, ($$render) => {
												if ($.get(isSelected)) $$render(consequent_11);
											});
										}

										var node_11 = $.sibling(node_10, 2);

										{
											var consequent_16 = ($$anchor) => {
												var div_28 = root_20();
												var div_29 = $.sibling($.child(div_28), 2);

												$.each(div_29, 21, () => $.get(routes), (route) => route.transportType + '-' + route.line + '-' + route.destination, ($$anchor, route) => {
													var div_30 = root_19();
													var span_11 = $.child(div_30);
													var node_12 = $.child(span_11);

													{
														var consequent_12 = ($$anchor) => {
															var svg = root_14();

															$.append($$anchor, svg);
														};

														var consequent_13 = ($$anchor) => {
															var svg_1 = root_15();

															$.append($$anchor, svg_1);
														};

														var consequent_14 = ($$anchor) => {
															var svg_2 = root_16();

															$.append($$anchor, svg_2);
														};

														var consequent_15 = ($$anchor) => {
															var svg_3 = root_17();

															$.append($$anchor, svg_3);
														};

														var alternate = ($$anchor) => {
															var svg_4 = root_18();

															$.append($$anchor, svg_4);
														};

														$.if(node_12, ($$render) => {
															if ($.get(route).transportType === "UBAHN") $$render(consequent_12); else if ($.get(route).transportType === "SBAHN") $$render(consequent_13, 1); else if ($.get(route).transportType === "TRAM") $$render(consequent_14, 2); else if ($.get(route).transportType === "BAHN") $$render(consequent_15, 3); else $$render(alternate, -1);
														});
													}

													var span_12 = $.sibling(node_12, 2);
													var text_16 = $.only_child(span_12, true);

													$.reset(span_11);

													var span_13 = $.sibling(span_11, 2);
													var text_17 = $.only_child(span_13, true);

													$.reset(div_30);

													$.template_effect(() => {
														$.set_attribute(div_30, 'title', `${$.get(route).line ?? ''} → ${$.get(route).destination ?? ''}`);
														$.set_text(text_16, $.get(route).line);
														$.set_text(text_17, $.get(route).destination);
													});

													$.append($$anchor, div_30);
												});

												$.reset(div_29);
												$.reset(div_28);
												$.append($$anchor, div_28);
											};

											var alternate_1 = ($$anchor) => {
												var div_31 = root_21();

												$.append($$anchor, div_31);
											};

											$.if(node_11, ($$render) => {
												if ($.get(routes).length > 0) $$render(consequent_16); else $$render(alternate_1, -1);
											});
										}

										$.reset(div_26);

										$.template_effect(
											($0) => {
												classes_3 = $.set_class(div_26, 1, 'substop-card svelte-15jn9j3', null, classes_3, { selected: $.get(isSelected), disabled: $.get(isDisabled) });
												$.set_checked(input_6, $.get(isSelected));
												input_6.disabled = $.get(isDisabled);
												$.set_text(text_14, `${$.get(subStop).name ?? ''} (${$0 ?? ''})`);
												$.set_text(text_15, $.get(subStop).id);
											},
											[
												() => getSubStopTitleForDisplay($.get(subStop).id, $.get(subStopData)?.title, $.get(subStop).platformValue, $.get(subStop).platformKind)
											]
										);

										$.delegated('change', input_6, () => handleSelectSubStop($.get(subStop).id, $.get(subStop).name, $.get(subStop).platformValue, $.get(subStop).platformKind, stopId));
										$.append($$anchor, div_26);
									}
								);

								$.reset(div_25);
								$.reset(div_24);

								$.template_effect(() => {
									$.set_text(text_13, $.get(mainStop).name);
									$.set_checked(input_5, $.get(selectFullStop));
								});

								$.delegated('change', input_5, (e) => $.set(selectFullStop, e.currentTarget.checked, true));
								$.append($$anchor, div_24);
							};

							$.if(node_9, ($$render) => {
								if ($.get(mainStop) && $.get(mainStop).subStops && $.get(mainStop).subStops.length > 0) $$render(consequent_17);
							});
						}

						$.append($$anchor, fragment_2);
					});

					$.reset(div_23);

					var node_13 = $.sibling(div_23, 2);

					{
						var consequent_18 = ($$anchor) => {
							var p_1 = root_24();

							$.append($$anchor, p_1);
						};

						$.if(node_13, ($$render) => {
							if ($.get(selectedSubStops).size === 0 && !$.get(selectFullStop)) $$render(consequent_18);
						});
					}

					$.append($$anchor, fragment);
				};

				$.if(node_7, ($$render) => {
					if ($.get(isLoadingSubStops)) $$render(consequent_9); else $$render(alternate_2, -1);
				});
			}

			$.reset(div_19);
			$.append($$anchor, div_19);
		};

		var consequent_45 = ($$anchor) => {
			var div_32 = root_39();
			var node_14 = $.child(div_32);

			{
				var consequent_38 = ($$anchor) => {
					var fragment_3 = root_35();
					var div_33 = $.sibling($.first_child(fragment_3), 4);
					var node_15 = $.child(div_33);

					$.each(node_15, 17, () => Array.from($.get(selectedSubStops).entries()), ([subStopId, subStopData]) => subStopId, ($$anchor, $$item) => {
						var $$array = $.derived(() => $.to_array($.get($$item), 2));
						let subStopId = () => $.get($$array)[0];
						let subStopData = () => $.get($$array)[1];
						const routes = $.derived(() => $.get(subStopRoutes).get(subStopId()) || []);
						var fragment_4 = $.comment();
						var node_16 = $.first_child(fragment_4);

						{
							var consequent_27 = ($$anchor) => {
								var div_34 = root_32();
								var div_35 = $.child(div_34);
								var h4_1 = $.child(div_35);
								var text_18 = $.only_child(h4_1, true);
								var button_5 = $.sibling(h4_1, 2);

								$.reset(div_35);

								var node_17 = $.sibling(div_35, 2);

								$.each(node_17, 17, () => $.get(directionMappings).get(subStopId()) || [], $.index, ($$anchor, group, groupIndex) => {
									var div_36 = root_30();
									var div_37 = $.child(div_36);
									var input_8 = $.child(div_37);

									$.remove_input_defaults(input_8);

									let classes_4;
									var button_6 = $.sibling(input_8, 2);

									$.reset(div_37);

									var node_18 = $.sibling(div_37, 2);

									{
										var consequent_20 = ($$anchor) => {
											var p_2 = root_27();

											$.append($$anchor, p_2);
										};

										var d_1 = $.derived(() => $.get(filterRoutesError) && (!$.get(group).title || $.get(group).title.trim() === ""));

										$.if(node_18, ($$render) => {
											if ($.get(d_1)) $$render(consequent_20);
										});
									}

									var div_38 = $.sibling(node_18, 2);
									var div_39 = $.sibling($.child(div_38), 2);

									$.each(div_39, 21, () => $.get(routes), (route) => route.transportType + '-' + route.line + '-' + route.destination, ($$anchor, route) => {
										const routeKey = $.derived(() => `${$.get(route).line} ${$.get(route).destination}`);
										const isSelected = $.derived(() => $.get(group).routes.includes($.get(routeKey)));
										var button_7 = root_28();
										let classes_5;
										var span_14 = $.child(button_7);
										var node_19 = $.child(span_14);

										{
											var consequent_21 = ($$anchor) => {
												var svg_5 = root_14();

												$.append($$anchor, svg_5);
											};

											var consequent_22 = ($$anchor) => {
												var svg_6 = root_15();

												$.append($$anchor, svg_6);
											};

											var consequent_23 = ($$anchor) => {
												var svg_7 = root_16();

												$.append($$anchor, svg_7);
											};

											var consequent_24 = ($$anchor) => {
												var svg_8 = root_17();

												$.append($$anchor, svg_8);
											};

											var alternate_3 = ($$anchor) => {
												var svg_9 = root_18();

												$.append($$anchor, svg_9);
											};

											$.if(node_19, ($$render) => {
												if ($.get(route).transportType === "UBAHN") $$render(consequent_21); else if ($.get(route).transportType === "SBAHN") $$render(consequent_22, 1); else if ($.get(route).transportType === "TRAM") $$render(consequent_23, 2); else if ($.get(route).transportType === "BAHN") $$render(consequent_24, 3); else $$render(alternate_3, -1);
											});
										}

										var span_15 = $.sibling(node_19, 2);
										var text_19 = $.only_child(span_15, true);

										$.reset(span_14);

										var span_16 = $.sibling(span_14, 2);
										var text_20 = $.only_child(span_16, true);

										$.reset(button_7);

										$.template_effect(() => {
											classes_5 = $.set_class(button_7, 1, 'route-filter-button svelte-15jn9j3', null, classes_5, { selected: $.get(isSelected) });
											$.set_text(text_19, $.get(route).line);
											$.set_text(text_20, $.get(route).destination);
										});

										$.delegated('click', button_7, () => toggleRouteInGroup(subStopId(), groupIndex, $.get(routeKey)));
										$.append($$anchor, button_7);
									});

									$.reset(div_39);

									var node_20 = $.sibling(div_39, 2);

									{
										var consequent_25 = ($$anchor) => {
											var p_3 = root_29();

											$.append($$anchor, p_3);
										};

										$.if(node_20, ($$render) => {
											if ($.get(filterRoutesError) && $.get(group).routes.length === 0) $$render(consequent_25);
										});
									}

									$.reset(div_38);
									$.reset(div_36);

									$.template_effect(
										($0) => {
											$.set_value(input_8, $.get(group).title);
											classes_4 = $.set_class(input_8, 1, 'direction-group-title-input svelte-15jn9j3', null, classes_4, { error: $0 });
										},
										[
											() => !$.get(group).title || $.get(group).title.trim() === ""
										]
									);

									$.delegated('input', input_8, (e) => updateDirectionGroupTitle(subStopId(), groupIndex, e.currentTarget.value));
									$.delegated('click', button_6, () => removeDirectionGroup(subStopId(), groupIndex));
									$.append($$anchor, div_36);
								});

								var node_21 = $.sibling(node_17, 2);

								{
									var consequent_26 = ($$anchor) => {
										var p_4 = root_31();

										$.append($$anchor, p_4);
									};

									var d_2 = $.derived(() => !$.get(directionMappings).get(subStopId()) || ($.get(directionMappings).get(subStopId())?.length ?? 0) === 0);

									$.if(node_21, ($$render) => {
										if ($.get(d_2)) $$render(consequent_26);
									});
								}

								$.reset(div_34);
								$.template_effect(() => $.set_text(text_18, subStopData().title));
								$.delegated('click', button_5, () => addDirectionGroup(subStopId()));
								$.append($$anchor, div_34);
							};

							$.if(node_16, ($$render) => {
								if ($.get(routes).length > 0) $$render(consequent_27);
							});
						}

						$.append($$anchor, fragment_4);
					});

					var node_22 = $.sibling(node_15, 2);

					$.each(node_22, 16, () => Array.from($.get(selectedStops)), (stopId) => stopId, ($$anchor, stopId) => {
						const stop = $.derived(() => $.get(searchResults).find((s) => s.id === stopId));
						const allRoutes = $.derived(() => new Map());
						const mainStopRoutes = $.derived(() => $.get(subStopRoutes).get(stopId) || []);
						var fragment_5 = root_34();
						var node_23 = $.first_child(fragment_5);

						$.each(node_23, 17, () => $.get(mainStopRoutes), (route) => `main-${stopId}-${route.line}-${route.destination}`, ($$anchor, route) => {
							const routeKey = $.derived(() => `${$.get(route).line} ${$.get(route).destination}`);
							var fragment_6 = $.comment();
							var node_24 = $.first_child(fragment_6);

							{
								var consequent_28 = ($$anchor) => {
									var text_21 = $.text();

									$.template_effect(($0) => $.set_text(text_21, $0), [
										() => void $.get(allRoutes).set($.get(routeKey), $.get(route))
									]);

									$.append($$anchor, text_21);
								};

								var d_3 = $.derived(() => !$.get(allRoutes).has($.get(routeKey)));

								$.if(node_24, ($$render) => {
									if ($.get(d_3)) $$render(consequent_28);
								});
							}

							$.append($$anchor, fragment_6);
						});

						var node_25 = $.sibling(node_23, 2);

						$.each(node_25, 17, () => Array.from($.get(selectedSubStops).entries()), ([subStopId]) => subStopId, ($$anchor, $$item) => {
							var $$array_1 = $.derived(() => $.to_array($.get($$item), 1));
							let subStopId = () => $.get($$array_1)[0];
							const routes = $.derived(() => $.get(subStopRoutes).get(subStopId()) || []);
							var fragment_8 = $.comment();
							var node_26 = $.first_child(fragment_8);

							$.each(node_26, 17, () => $.get(routes), (route) => `sub-${subStopId()}-${route.line}-${route.destination}`, ($$anchor, route) => {
								const routeKey = $.derived(() => `${$.get(route).line} ${$.get(route).destination}`);
								var fragment_9 = $.comment();
								var node_27 = $.first_child(fragment_9);

								{
									var consequent_29 = ($$anchor) => {
										var text_22 = $.text();

										$.template_effect(($0) => $.set_text(text_22, $0), [
											() => void $.get(allRoutes).set($.get(routeKey), $.get(route))
										]);

										$.append($$anchor, text_22);
									};

									var d_4 = $.derived(() => !$.get(allRoutes).has($.get(routeKey)));

									$.if(node_27, ($$render) => {
										if ($.get(d_4)) $$render(consequent_29);
									});
								}

								$.append($$anchor, fragment_9);
							});

							$.append($$anchor, fragment_8);
						});

						var node_28 = $.sibling(node_25, 2);

						{
							var consequent_37 = ($$anchor) => {
								var div_40 = root_32();
								var div_41 = $.child(div_40);
								var h4_2 = $.child(div_41);
								var text_23 = $.only_child(h4_2);
								var button_8 = $.sibling(h4_2, 2);

								$.reset(div_41);

								var node_29 = $.sibling(div_41, 2);

								$.each(node_29, 17, () => $.get(directionMappings).get(stopId) || [], $.index, ($$anchor, group, groupIndex) => {
									var div_42 = root_30();
									var div_43 = $.child(div_42);
									var input_9 = $.child(div_43);

									$.remove_input_defaults(input_9);

									let classes_6;
									var button_9 = $.sibling(input_9, 2);

									$.reset(div_43);

									var node_30 = $.sibling(div_43, 2);

									{
										var consequent_30 = ($$anchor) => {
											var p_5 = root_27();

											$.append($$anchor, p_5);
										};

										var d_5 = $.derived(() => $.get(filterRoutesError) && (!$.get(group).title || $.get(group).title.trim() === ""));

										$.if(node_30, ($$render) => {
											if ($.get(d_5)) $$render(consequent_30);
										});
									}

									var div_44 = $.sibling(node_30, 2);
									var div_45 = $.sibling($.child(div_44), 2);

									$.each(div_45, 21, () => Array.from($.get(allRoutes).values()), (route) => route.transportType + '-' + route.line + '-' + route.destination, ($$anchor, route) => {
										const routeKey = $.derived(() => `${$.get(route).line} ${$.get(route).destination}`);
										const isSelected = $.derived(() => $.get(group).routes.includes($.get(routeKey)));
										var button_10 = root_28();
										let classes_7;
										var span_17 = $.child(button_10);
										var node_31 = $.child(span_17);

										{
											var consequent_31 = ($$anchor) => {
												var svg_10 = root_14();

												$.append($$anchor, svg_10);
											};

											var consequent_32 = ($$anchor) => {
												var svg_11 = root_15();

												$.append($$anchor, svg_11);
											};

											var consequent_33 = ($$anchor) => {
												var svg_12 = root_16();

												$.append($$anchor, svg_12);
											};

											var consequent_34 = ($$anchor) => {
												var svg_13 = root_17();

												$.append($$anchor, svg_13);
											};

											var alternate_4 = ($$anchor) => {
												var svg_14 = root_18();

												$.append($$anchor, svg_14);
											};

											$.if(node_31, ($$render) => {
												if ($.get(route).transportType === "UBAHN") $$render(consequent_31); else if ($.get(route).transportType === "SBAHN") $$render(consequent_32, 1); else if ($.get(route).transportType === "TRAM") $$render(consequent_33, 2); else if ($.get(route).transportType === "BAHN") $$render(consequent_34, 3); else $$render(alternate_4, -1);
											});
										}

										var span_18 = $.sibling(node_31, 2);
										var text_24 = $.only_child(span_18, true);

										$.reset(span_17);

										var span_19 = $.sibling(span_17, 2);
										var text_25 = $.only_child(span_19, true);

										$.reset(button_10);

										$.template_effect(() => {
											classes_7 = $.set_class(button_10, 1, 'route-filter-button svelte-15jn9j3', null, classes_7, { selected: $.get(isSelected) });
											$.set_text(text_24, $.get(route).line);
											$.set_text(text_25, $.get(route).destination);
										});

										$.delegated('click', button_10, () => toggleRouteInGroup(stopId, groupIndex, $.get(routeKey)));
										$.append($$anchor, button_10);
									});

									$.reset(div_45);

									var node_32 = $.sibling(div_45, 2);

									{
										var consequent_35 = ($$anchor) => {
											var p_6 = root_29();

											$.append($$anchor, p_6);
										};

										$.if(node_32, ($$render) => {
											if ($.get(filterRoutesError) && $.get(group).routes.length === 0) $$render(consequent_35);
										});
									}

									$.reset(div_44);
									$.reset(div_42);

									$.template_effect(
										($0) => {
											$.set_value(input_9, $.get(group).title);
											classes_6 = $.set_class(input_9, 1, 'direction-group-title-input svelte-15jn9j3', null, classes_6, { error: $0 });
										},
										[
											() => !$.get(group).title || $.get(group).title.trim() === ""
										]
									);

									$.delegated('input', input_9, (e) => updateDirectionGroupTitle(stopId, groupIndex, e.currentTarget.value));
									$.delegated('click', button_9, () => removeDirectionGroup(stopId, groupIndex));
									$.append($$anchor, div_42);
								});

								var node_33 = $.sibling(node_29, 2);

								{
									var consequent_36 = ($$anchor) => {
										var p_7 = root_33();

										$.append($$anchor, p_7);
									};

									var d_6 = $.derived(() => !$.get(directionMappings).get(stopId) || ($.get(directionMappings).get(stopId)?.length ?? 0) === 0);

									$.if(node_33, ($$render) => {
										if ($.get(d_6)) $$render(consequent_36);
									});
								}

								$.reset(div_40);
								$.template_effect(() => $.set_text(text_23, `${$.get(stop)?.name ?? ''} (Main Stop)`));
								$.delegated('click', button_8, () => addDirectionGroup(stopId));
								$.append($$anchor, div_40);
							};

							$.if(node_28, ($$render) => {
								if ($.get(allRoutes).size > 0) $$render(consequent_37);
							});
						}

						$.append($$anchor, fragment_5);
					});

					$.reset(div_33);
					$.append($$anchor, fragment_3);
				};

				var alternate_6 = ($$anchor) => {
					var fragment_11 = root_38();
					var div_46 = $.sibling($.first_child(fragment_11), 4);

					$.each(div_46, 21, () => Array.from($.get(selectedSubStops).entries()), ([subStopId, subStopData]) => subStopId, ($$anchor, $$item) => {
						var $$array_2 = $.derived(() => $.to_array($.get($$item), 2));
						let subStopId = () => $.get($$array_2)[0];
						let subStopData = () => $.get($$array_2)[1];
						const routes = $.derived(() => $.get(subStopRoutes).get(subStopId()) || []);
						var fragment_12 = $.comment();
						var node_34 = $.first_child(fragment_12);

						{
							var consequent_44 = ($$anchor) => {
								var div_47 = root_37();
								var h4_3 = $.child(div_47);
								var text_26 = $.child(h4_3);
								var node_35 = $.sibling(text_26);

								{
									var consequent_39 = ($$anchor) => {
										var span_20 = root_36();
										var text_27 = $.only_child(span_20);

										$.template_effect(($0) => $.set_text(text_27, `(${$0 ?? ''} selected)`), [() => $.get(filterSelectedRoutes).get(subStopId())?.size]);
										$.append($$anchor, span_20);
									};

									var d_7 = $.derived(() => $.get(filterSelectedRoutes).get(subStopId())?.size);

									$.if(node_35, ($$render) => {
										if ($.get(d_7)) $$render(consequent_39);
									});
								}

								$.reset(h4_3);

								var div_48 = $.sibling(h4_3, 2);

								$.each(div_48, 21, () => $.get(routes), (route) => route.transportType + '-' + route.line + '-' + route.destination, ($$anchor, route) => {
									const routeKey = $.derived(() => buildRouteKey($.get(route).line, $.get(route).destination));
									const isSelected = $.derived(() => $.get(filterSelectedRoutes).get(subStopId())?.has($.get(routeKey)) || false);
									var button_11 = root_28();
									let classes_8;
									var span_21 = $.child(button_11);
									var node_36 = $.child(span_21);

									{
										var consequent_40 = ($$anchor) => {
											var svg_15 = root_14();

											$.append($$anchor, svg_15);
										};

										var consequent_41 = ($$anchor) => {
											var svg_16 = root_15();

											$.append($$anchor, svg_16);
										};

										var consequent_42 = ($$anchor) => {
											var svg_17 = root_16();

											$.append($$anchor, svg_17);
										};

										var consequent_43 = ($$anchor) => {
											var svg_18 = root_17();

											$.append($$anchor, svg_18);
										};

										var alternate_5 = ($$anchor) => {
											var svg_19 = root_18();

											$.append($$anchor, svg_19);
										};

										$.if(node_36, ($$render) => {
											if ($.get(route).transportType === "UBAHN") $$render(consequent_40); else if ($.get(route).transportType === "SBAHN") $$render(consequent_41, 1); else if ($.get(route).transportType === "TRAM") $$render(consequent_42, 2); else if ($.get(route).transportType === "BAHN") $$render(consequent_43, 3); else $$render(alternate_5, -1);
										});
									}

									var span_22 = $.sibling(node_36, 2);
									var text_28 = $.only_child(span_22, true);

									$.reset(span_21);

									var span_23 = $.sibling(span_21, 2);
									var text_29 = $.only_child(span_23, true);

									$.reset(button_11);

									$.template_effect(() => {
										classes_8 = $.set_class(button_11, 1, 'route-filter-button svelte-15jn9j3', null, classes_8, { selected: $.get(isSelected) });
										$.set_text(text_28, $.get(route).line);
										$.set_text(text_29, $.get(route).destination);
									});

									$.delegated('click', button_11, () => toggleRouteFilter(subStopId(), $.get(routeKey)));
									$.append($$anchor, button_11);
								});

								$.reset(div_48);
								$.reset(div_47);
								$.template_effect(() => $.set_text(text_26, `${subStopData().title ?? ''} `));
								$.append($$anchor, div_47);
							};

							$.if(node_34, ($$render) => {
								if ($.get(routes).length > 0) $$render(consequent_44);
							});
						}

						$.append($$anchor, fragment_12);
					});

					$.reset(div_46);
					$.next(2);
					$.append($$anchor, fragment_11);
				};

				$.if(node_14, ($$render) => {
					if ($.get(selectFullStop)) $$render(consequent_38); else $$render(alternate_6, -1);
				});
			}

			$.reset(div_32);
			$.append($$anchor, div_32);
		};

		var consequent_51 = ($$anchor) => {
			var div_49 = root_48();
			var div_50 = $.sibling($.child(div_49), 4);
			var node_37 = $.child(div_50);

			{
				var consequent_47 = ($$anchor) => {
					var fragment_13 = $.comment();
					var node_38 = $.first_child(fragment_13);

					$.each(node_38, 16, () => Array.from($.get(selectedStops)), (stopId) => stopId, ($$anchor, stopId) => {
						const stop = $.derived(() => $.get(searchResults).find((s) => s.id === stopId));
						var div_51 = root_43();
						var h4_4 = $.child(div_51);
						var text_30 = $.only_child(h4_4);
						var div_52 = $.sibling(h4_4, 2);
						var div_53 = $.child(div_52);
						var code = $.sibling($.child(div_53), 2);
						var text_31 = $.only_child(code, true);

						$.reset(div_53);

						var div_54 = $.sibling(div_53, 4);
						var div_55 = $.sibling($.child(div_54), 2);

						$.each(div_55, 23, () => $.get(directionMappings).get(stopId) || [], (group, groupIndex) => `${stopId}-group-${groupIndex}`, ($$anchor, group) => {
							var div_56 = root_42();
							var strong_3 = $.child(div_56);
							var text_32 = $.only_child(strong_3);
							var div_57 = $.sibling(strong_3, 2);
							var node_39 = $.child(div_57);

							{
								var consequent_46 = ($$anchor) => {
									var fragment_14 = $.comment();
									var node_40 = $.first_child(fragment_14);

									$.each(node_40, 16, () => $.get(group).routes, (routeKey) => routeKey, ($$anchor, routeKey) => {
										const routeParts = $.derived(() => routeKey.split(' '));
										const lineNumber = $.derived(() => $.get(routeParts)[0]);
										var span_24 = root_40();
										var text_33 = $.only_child(span_24, true);

										$.template_effect(() => $.set_text(text_33, $.get(lineNumber)));
										$.append($$anchor, span_24);
									});

									$.append($$anchor, fragment_14);
								};

								var alternate_7 = ($$anchor) => {
									var span_25 = root_41();

									$.append($$anchor, span_25);
								};

								$.if(node_39, ($$render) => {
									if ($.get(group).routes.length > 0) $$render(consequent_46); else $$render(alternate_7, -1);
								});
							}

							$.reset(div_57);
							$.reset(div_56);
							$.template_effect(() => $.set_text(text_32, `"${($.get(group).title || '(unnamed)') ?? ''}"`));
							$.append($$anchor, div_56);
						});

						$.reset(div_55);
						$.reset(div_54);
						$.reset(div_52);
						$.reset(div_51);

						$.template_effect(() => {
							$.set_text(text_30, `${$.get(stop)?.name ?? ''} (Full Stop)`);
							$.set_text(text_31, stopId);
						});

						$.append($$anchor, div_51);
					});

					$.append($$anchor, fragment_13);
				};

				$.if(node_37, ($$render) => {
					if ($.get(selectFullStop)) $$render(consequent_47);
				});
			}

			var node_41 = $.sibling(node_37, 2);

			$.each(node_41, 17, () => Array.from($.get(selectedSubStops).entries()), ([subStopId, subStopData]) => subStopId, ($$anchor, $$item) => {
				var $$array_3 = $.derived(() => $.to_array($.get($$item), 2));
				let subStopId = () => $.get($$array_3)[0];
				let subStopData = () => $.get($$array_3)[1];
				const stop = $.derived(() => $.get(searchResults).find((s) => s.id === Array.from($.get(selectedStops))[0]));
				var div_58 = root_47();
				var h4_5 = $.child(div_58);
				var text_34 = $.only_child(h4_5);
				var div_59 = $.sibling(h4_5, 2);
				var div_60 = $.child(div_59);
				var code_1 = $.sibling($.child(div_60), 2);
				var text_35 = $.only_child(code_1, true);

				$.reset(div_60);

				var div_61 = $.sibling(div_60, 2);
				var span_26 = $.sibling($.child(div_61), 2);
				var text_36 = $.only_child(span_26, true);

				$.reset(div_61);

				var node_42 = $.sibling(div_61, 2);

				{
					var consequent_49 = ($$anchor) => {
						var fragment_15 = root_44();
						var div_62 = $.sibling($.first_child(fragment_15), 2);
						var div_63 = $.sibling($.child(div_62), 2);

						$.each(div_63, 23, () => $.get(directionMappings).get(subStopId()) || [], (group, groupIndex) => `${subStopId()}-group-${groupIndex}`, ($$anchor, group) => {
							var div_64 = root_42();
							var strong_4 = $.child(div_64);
							var text_37 = $.only_child(strong_4);
							var div_65 = $.sibling(strong_4, 2);
							var node_43 = $.child(div_65);

							{
								var consequent_48 = ($$anchor) => {
									var fragment_16 = $.comment();
									var node_44 = $.first_child(fragment_16);

									$.each(node_44, 16, () => $.get(group).routes, (routeKey) => routeKey, ($$anchor, routeKey) => {
										const routeParts = $.derived(() => routeKey.split(' '));
										const lineNumber = $.derived(() => $.get(routeParts)[0]);
										var span_27 = root_40();
										var text_38 = $.only_child(span_27, true);

										$.template_effect(() => $.set_text(text_38, $.get(lineNumber)));
										$.append($$anchor, span_27);
									});

									$.append($$anchor, fragment_16);
								};

								var alternate_8 = ($$anchor) => {
									var span_28 = root_41();

									$.append($$anchor, span_28);
								};

								$.if(node_43, ($$render) => {
									if ($.get(group).routes.length > 0) $$render(consequent_48); else $$render(alternate_8, -1);
								});
							}

							$.reset(div_65);
							$.reset(div_64);
							$.template_effect(() => $.set_text(text_37, `"${($.get(group).title || '(unnamed)') ?? ''}"`));
							$.append($$anchor, div_64);
						});

						$.reset(div_63);
						$.reset(div_62);
						$.append($$anchor, fragment_15);
					};

					var d_8 = $.derived(() => $.get(selectFullStop) && $.get(directionMappings).has(subStopId()));

					var alternate_9 = ($$anchor) => {
						var fragment_17 = root_46();
						var node_45 = $.sibling($.first_child(fragment_17), 2);

						{
							var consequent_50 = ($$anchor) => {
								var div_66 = root_45();
								var div_67 = $.sibling($.child(div_66), 2);

								$.each(div_67, 20, () => Array.from($.get(filterSelectedRoutes).get(subStopId()) || []), (routeKey) => routeKey, ($$anchor, routeKey) => {
									const lineNumber = $.derived(() => routeKeyToLine(routeKey));
									var span_29 = root_40();
									var text_39 = $.only_child(span_29, true);

									$.template_effect(() => $.set_text(text_39, $.get(lineNumber)));
									$.append($$anchor, span_29);
								});

								$.reset(div_67);
								$.reset(div_66);
								$.append($$anchor, div_66);
							};

							var d_9 = $.derived(() => $.get(filterSelectedRoutes).has(subStopId()));

							$.if(node_45, ($$render) => {
								if ($.get(d_9)) $$render(consequent_50);
							});
						}

						$.append($$anchor, fragment_17);
					};

					$.if(node_42, ($$render) => {
						if ($.get(d_8)) $$render(consequent_49); else $$render(alternate_9, -1);
					});
				}

				$.next(4);
				$.reset(div_59);
				$.reset(div_58);

				$.template_effect(() => {
					$.set_text(text_34, `${$.get(stop)?.name ?? ''} - ${subStopData().title ?? ''}`);
					$.set_text(text_35, subStopId());
					$.set_text(text_36, subStopData().title);
				});

				$.append($$anchor, div_58);
			});

			$.reset(div_50);
			$.next(2);
			$.reset(div_49);
			$.append($$anchor, div_49);
		};

		$.if(node, ($$render) => {
			if ($.get(currentStep) === "target") $$render(consequent_1); else if ($.get(currentStep) === "route-details") $$render(consequent_2, 1); else if ($.get(currentStep) === "search") $$render(consequent_6, 2); else if ($.get(currentStep) === "select") $$render(consequent_8, 3); else if ($.get(currentStep) === "substops") $$render(consequent_19, 4); else if ($.get(currentStep) === "filter-routes") $$render(consequent_45, 5); else if ($.get(currentStep) === "configure") $$render(consequent_51, 6);
		});
	}

	$.reset(div_3);

	var div_68 = $.sibling(div_3, 2);
	var node_46 = $.child(div_68);

	{
		var consequent_52 = ($$anchor) => {
			var button_12 = root_49();

			$.delegated('click', button_12, function (...$$args) {
				$$props.onCancel?.apply(this, $$args);
			});

			$.append($$anchor, button_12);
		};

		var consequent_53 = ($$anchor) => {
			var fragment_18 = root_50();
			var button_13 = $.first_child(fragment_18);
			var button_14 = $.sibling(button_13, 2);
			var button_15 = $.sibling(button_14, 2);

			$.template_effect(($0) => button_15.disabled = $0, [
				() => !$.get(newRouteTitle).trim() || !$.get(newRoutePath).trim()
			]);

			$.delegated('click', button_13, () => $.set(currentStep, "target"));

			$.delegated('click', button_14, function (...$$args) {
				$$props.onCancel?.apply(this, $$args);
			});

			$.delegated('click', button_15, () => $.set(currentStep, "search"));
			$.append($$anchor, fragment_18);
		};

		var consequent_54 = ($$anchor) => {
			var fragment_19 = root_51();
			var button_16 = $.first_child(fragment_19);
			var button_17 = $.sibling(button_16, 2);

			$.delegated('click', button_16, () => $.set(currentStep, $.get(configTarget) === "route" ? "route-details" : "target", true));

			$.delegated('click', button_17, function (...$$args) {
				$$props.onCancel?.apply(this, $$args);
			});

			$.append($$anchor, fragment_19);
		};

		var consequent_55 = ($$anchor) => {
			var fragment_20 = root_52();
			var button_18 = $.first_child(fragment_20);
			var button_19 = $.sibling(button_18, 2);
			var button_20 = $.sibling(button_19, 2);
			var text_40 = $.only_child(button_20);

			$.template_effect(() => {
				button_20.disabled = $.get(selectedCount) === 0;
				$.set_text(text_40, `Next (${$.get(selectedCount) ?? ''} selected)`);
			});

			$.delegated('click', button_18, () => $.set(currentStep, "search"));

			$.delegated('click', button_19, function (...$$args) {
				$$props.onCancel?.apply(this, $$args);
			});

			$.delegated('click', button_20, proceedToSubStops);
			$.append($$anchor, fragment_20);
		};

		var consequent_56 = ($$anchor) => {
			var fragment_21 = root_50();
			var button_21 = $.first_child(fragment_21);
			var button_22 = $.sibling(button_21, 2);
			var button_23 = $.sibling(button_22, 2);

			$.delegated('click', button_21, () => $.set(currentStep, "select"));

			$.delegated('click', button_22, function (...$$args) {
				$$props.onCancel?.apply(this, $$args);
			});

			$.delegated('click', button_23, proceedToRouteFiltering);
			$.append($$anchor, fragment_21);
		};

		var consequent_57 = ($$anchor) => {
			var fragment_22 = root_50();
			var button_24 = $.first_child(fragment_22);
			var button_25 = $.sibling(button_24, 2);
			var button_26 = $.sibling(button_25, 2);

			$.delegated('click', button_24, () => $.set(currentStep, "substops"));

			$.delegated('click', button_25, function (...$$args) {
				$$props.onCancel?.apply(this, $$args);
			});

			$.delegated('click', button_26, proceedToConfiguration);
			$.append($$anchor, fragment_22);
		};

		var consequent_58 = ($$anchor) => {
			var fragment_23 = root_53();
			var button_27 = $.first_child(fragment_23);
			var button_28 = $.sibling(button_27, 2);
			var button_29 = $.sibling(button_28, 2);

			$.delegated('click', button_27, () => {
				// Go back to filter-routes if there were substops with routes OR if full stop was selected
				const hasSubStopsWithRoutes = Array.from($.get(selectedSubStops).keys()).some((subStopId) => {
					const routes = $.get(subStopRoutes).get(subStopId) || [];

					return routes.length > 0;
				});

				if (hasSubStopsWithRoutes || $.get(selectFullStop)) {
					$.set(currentStep, "filter-routes");
				} else {
					const hasSubStops = Array.from($.get(selectedStops)).some((id) => {
						const stop = $.get(searchResults).find((r) => r.id === id);

						return stop && stop.subStops && stop.subStops.length > 0;
					});

					$.set(currentStep, hasSubStops ? "substops" : "select", true);
				}
			});

			$.delegated('click', button_28, function (...$$args) {
				$$props.onCancel?.apply(this, $$args);
			});

			$.delegated('click', button_29, handleComplete);
			$.append($$anchor, fragment_23);
		};

		$.if(node_46, ($$render) => {
			if ($.get(currentStep) === "target") $$render(consequent_52); else if ($.get(currentStep) === "route-details") $$render(consequent_53, 1); else if ($.get(currentStep) === "search") $$render(consequent_54, 2); else if ($.get(currentStep) === "select") $$render(consequent_55, 3); else if ($.get(currentStep) === "substops") $$render(consequent_56, 4); else if ($.get(currentStep) === "filter-routes") $$render(consequent_57, 5); else if ($.get(currentStep) === "configure") $$render(consequent_58, 6);
		});
	}

	$.reset(div_68);
	$.reset(div_1);
	$.reset(div);

	$.delegated('click', div, (event) => {
		if (event.target === event.currentTarget) {
			$$props.onCancel();
		}
	});

	$.delegated('keydown', div, handleKeydown);

	$.delegated('click', button, function (...$$args) {
		$$props.onCancel?.apply(this, $$args);
	});

	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click', 'keydown', 'input', 'change']);